export const frData = {
    "locale": {
        "home_instavc_build": "Construisez des relations efficaces entre les entreprises, vos partenaires et vos employ\u00e9s",
        "home_instavc_conference_platform": "Nos solutions de vid\u00e9oconf\u00e9rence fournissent une exp\u00e9rience utilisateur in\u00e9gal\u00e9e",
        "home_instavc_start_conference": "D\u00c9MARRER LA R\u00c9UNION | REJOINDRE LA R\u00c9UNION | R\u00c9UNION INSTANTAN\u00c9E",
        "home_instavc_Hippa": "HIPAA \u00c9LIGIBLE ET PCI DSS, SOC, ISO\/EIC 27001, ISO\/EIC 27017, ISO\/EIC 27018, ET ISO 9001 CONFORME.",
        "home_instavc_copyrights": "2018 - instaVC - PeopleLink Unified Communications Pvt. Ltd.",
        "home_instavc_terms_agree": "Je suis d'accord avec le",
        "home_instavc_terms": "Conditions g\u00e9n\u00e9rales",
        "instavc_login": "Se connecter",
        "instavc_login_email": "Email",
        "instavc_login_password": "Mot de passe",
        "instavc_login_button": "SE CONNECTER",
        "instavc_login_forgotpassword": "Mot de passe oubli\u00e9 ?",
        "instavc_login_have_account": "Vous n'avez pas de compte ?",
        "instavc_login_signup": "Inscription",
        "instavc_signup": "S'inscrire",
        "instavc_signup_firstname": "Pr\u00e9nom",
        "instavc_signup_lastname": "Nom",
        "instavc_signup_email": "Email",
        "instavc_signup_password": "Mot de passe",
        "instavc_signup_cpassword": "Confirmer le mot de passe",
        "instavc_signup_button": "S'inscrire",
        "instavc_signup_already_have_account": "Vous avez d\u00e9j\u00e0 un compte ?",
        "instavc_signup_login": "Se connecter",
        "instavc_signup_fname_error": "Le pr\u00e9nom ne doit contenir que des lettres de l'alphabet",
        "instavc_signup_lname_error": "Le nom ne doit contenir que des lettres de l'alphabet",
        "instavc_signup_email_error": "L'email doit \u00eatre dans un format appropri\u00e9",
        "instavc_signup_password_error": "Le mot de passe doit comporter six caract\u00e8res et la combinaison d'une majuscule, d'une minuscule, d'un chiffre et d'un caract\u00e8re sp\u00e9cial",
        "instavc_signup_cpassword_error": "La confirmation du mot de passe doit correspondre au mot de passe ci-dessus",
        "instavc_forgotpassword_link": "Nous vous enverrons un lien via email. Il vous suffit de cliquer sur le lien et de d\u00e9finir votre nouveau mot de passe",
        "instavc_forgotpassword_email": "Saisissez l'email utilis\u00e9 lors de votre enregistrement dans instaVC",
        "instavc_forgotpassword": "Mot de passe oubli\u00e9",
        "instavc_forgotpassword_button": "Mot de passe oubli\u00e9",
        "instavc_confirmpass_heading": "Cr\u00e9ez un nouveau mot de passe en remplissant le formulaire.",
        "instavc_confirmpass_verificationcode": "Entrez le code de v\u00e9rification",
        "instavc_confirmpass_newpassword": "Saisissez un nouveau mot de passe",
        "instavc_confirmpass_retypepassword": "Ressaisissez le nouveau mot de passe",
        "instavc_confirmpass_button": "CR\u00c9ER UN NOUVEAU MOT DE PASSE",
        "instavc_forgotpassword_signin": "S'enregistrer",
        "instavc_forgotpassword_passwordcreated": "F\u00e9licitations ! Votre nouveau mot de passe a \u00e9t\u00e9 cr\u00e9\u00e9, vous pouvez maintenant vous connecter \u00e0 instaVC.",
        "instavc_dashboard": "TABLEAU DE BORD",
        "instavc_dashboard_schedule": "PLANIFICATION DE LA REUNION",
        "instavc_dashboard_meetinglist": "R\u00c9UNIONS TERMIN\u00c9ES",
        "instavc_dashboard_conferenceplatform": "Nos solutions de vid\u00e9oconf\u00e9rence fournissent une exp\u00e9rience utilisateur in\u00e9gal\u00e9e",
        "instavc_dashboard_SC_room": "D\u00e9marrez une r\u00e9union",
        "instavc_dashboard_SC_roomlist": "que vous avez planifi\u00e9e",
        "instavc_dashboard_startconference": "D\u00c9MARREZ LA R\u00c9UNION",
        "instavc_dashboard_JC": "Rejoindre une r\u00e9union",
        "instavc_dashboard_JC_ID": "\u00e0 laquelle vous \u00eates invit\u00e9",
        "instavc_dashboard_JC_button": "REJOINDRE UNE CONFERENCE",
        "instavc_dashboard_SC": "D\u00e9marrez une r\u00e9union",
        "instavc_dashboard_SC_p2p": "en s\u00e9lectionnant une salle libre dans votre liste",
        "instavc_dashboard_instaconference": "INSTA CONFERENCE",
        "instavc_dashboard_buynow": "ACHETER MAINTENANT",
        "instavc_dashboard_myprofile": "Mon profil",
        "instavc_dashboard_settings": "Param\u00e8tres",
        "instavc_dashboard_myadmin": "Mon administration",
        "instavc_dashboard_affiliate": "Mon affili\u00e9",
        "instavc_dashboard_logout": "D\u00e9connexion",
        "conference_myrooms": "Mes Salles",
        "conference_myrooms_host": "Organisateur :",
        "conference_myrooms_roomhost": "Vous \u00eates l'organisateur pour cette salle.",
        "conference_myrooms_search": "Rechercher ...",
        "conference_myrooms_hostuser": "Participant organisateur",
        "conference_myrooms_gotopremium": "Achetez une licence",
        "conference_myrooms_buynow": "Acheter maintenant",
        "conference_myrooms_renewal": "Renouvellement",
        "conference_setup": "Configuration",
        "conference_myrooms_renewnow": "Renouveler maintenant",
        "conference_myrooms_join": "Rejoindre",
        "conference_myrooms_setup": "Configuration de la salle",
        "conference_myrooms_sethost_email": "Devenez l'organisateur, ou saisissez une adresse email d'utilisateur pour qu'il devienne organisateur",
        "conference_myrooms_selfhost": "Devenez l'organisateur",
        "conference_myrooms_otherhost": "OU - Si vous voulez faire de n'importe quel utilisateur un organisateur, saisissez son email.",
        "conference_myrooms_email": "Adresse email",
        "conference_myrooms_cancel": "Annuler",
        "conference_myrooms_apply": "Appliquer",
        "view_schedule_myrooms": "Mes Salles",
        "view_schedule_search": "Rechercher ...",
        "view_schedule_schedule": "Programme",
        "view_schedule_Videorecording": "Enregistrements vid\u00e9o",
        "view_schedule_calender": "Vous trouverez ci-dessous le calendrier pour consulter les planifications de r\u00e9unions de cette salle",
        "view_recordings": "Enregistrements vid\u00e9o",
        "view_recordings_search": "Recherchez",
        "view_recordings_month": "Ce mois-ci",
        "view_recordings_week": "Les 7 derniers jours",
        "view_recordings_today": "Aujourd'hui",
        "no_recordings": "Pas encore d'enregistrements !",
        "no_recordings_message": "Il n'y a pas de vid\u00e9os ici pour le moment.",
        "no_recordings_startmessage": "Une fois que vous avez commenc\u00e9 \u00e0 enregistrer, vous pouvez regarder toutes vos vid\u00e9os ici.",
        "stop_recording": "Voulez-vous arr\u00eater cet enregistrement ?",
        "stop_recording_agree": "Accord",
        "stop_recording_disagree": "D\u00e9saccord",
        "conference_in_use": "La r\u00e9union est en cours",
        "conference_mode": "Mode de la r\u00e9union",
        "large_conference_mode": "Mode \"Grande R\u00e9union\"",
        "conference_setup_configuration": "Configuration",
        "conference_setup_generateid": "Pas d'identifiant r\u00e9union, g\u00e9n\u00e9rez en un !",
        "conference_setup_regenerate": "R\u00e9g\u00e9n\u00e9rer",
        "conference_setup_meetingid": "Identifiant de la r\u00e9union",
        "conference_setup_camera": "Cam\u00e9ra HD FaceTime",
        "conference_setup_defaultmicrophone": "Par d\u00e9faut - Microphone interne (int\u00e9gr\u00e9)",
        "conference_setup_microphone": "Microphone interne (int\u00e9gr\u00e9)",
        "conference_setup_volume": "Volume",
        "conference_setup_videomode": "Mode vid\u00e9o",
        "conference_setup_forward": "Direct",
        "conference_setup_mix": "Mixage",
        "conference_setup_invite": "Inviter",
        "conference_setup_invitepeople": "Inviter des personnes",
        "conference_setup_invitefriends": "Invitez vos amis et coll\u00e8gues pour collaborer.",
        "conference_setup_invite_directlink": "Lien direct vers votre salle",
        "conference_setup_invite_sharelink": "Partagez ce lien avec vos participants pour qu'ils se joignent \u00e0 votre r\u00e9union",
        "conference_setup_invite_link": "https:\/\/connect.instavc.com\/conference-guest\/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9\/f",
        "conference_setup_invitebyemail": "Invitation par email",
        "conference_setup_invite_enteremail": "Saisissez votre adresse email pr\u00e9f\u00e9r\u00e9e pour inviter vos participants",
        "conference_setup_invite_emailid": "Adresse email",
        "conference_setup_invite_close": "FERMER",
        "conference_setup_invite_button": "INVITER",
        "conference_setup_advancesettings": "Param\u00e9trage avanc\u00e9",
        "conference_setup_changeresolution": "Choisir une r\u00e9solution",
        "conference_setup_lowbandwidth": "Faible bande passante",
        "conference_setup_poornetwork": "R\u00e9seau faible",
        "conference_setup_vga": "VGA - (640x480)",
        "conference_setup_vga_graphics": "Pour une r\u00e9solution vid\u00e9o VGA",
        "conference_setup_hd1080": "HD1080p - (1920x1080)",
        "conference_setup_fhd": "Pour une r\u00e9solution vid\u00e9o haute d\u00e9finition  (Full HD)",
        "conference_setup_4k": "4K - (3840 x 2160)",
        "conference_setup_4k_fhd": "Pour une r\u00e9solution vid\u00e9o haute d\u00e9finition  (Full HD)",
        "conference_setup_sif": "SIF - (320x240)",
        "conference_setup_sif_vr": "Pour la r\u00e9solution vid\u00e9o SIF",
        "conference_setup_hd720": "HD720p - (1280x720)",
        "conference_setup_hd720_vr": "Pour la r\u00e9solution vid\u00e9o haute d\u00e9finition (HD)",
        "conference_setup_2k": "2K - (2048\u00d71080)",
        "conference_setup_2k_fhd": "Pour une r\u00e9solution vid\u00e9o haute d\u00e9finition  (Full HD)",
        "conference_setup_broadcastoptions": "Options de diffusion",
        "conference_setup_enable": "Activer",
        "conference_setup_disable": "D\u00e9sactiver",
        "conference_setup_reportquality": "Communiquer nous les statistiques de qualit\u00e9 afin d'am\u00e9liorer les appels vocaux et vid\u00e9o",
        "conference_setup_havetroubleshoot": "Si vous souhaitez ex\u00e9cuter l'outil de d\u00e9pannage pour votre r\u00e9union, cliquez sur le lien suivant",
        "conference_setup_conferencetroubleshoot": "D\u00c9PANNAGE",
        "conference_troubleshoot": "D\u00e9pannage",
        "conference_troubleshoot_faq": "FAQ",
        "conference_troubleshoot_emailreport": "RAPPORT PAR COURRIEL",
        "conference_troubleshoot_gotoconference": "REJOINDRE LA R\u00c9UNION",
        "conference_troubleshoot_os": "Syst\u00e8me d'exploitation",
        "conference_troubleshoot_version": "version",
        "conference_troubleshoot_browser": "Navigateur",
        "conference_troubleshoot_chromeversion": "Version chrome",
        "conference_troubleshoot_privatebrowsing": "Navigation priv\u00e9e",
        "conference_troubleshoot_displayresolution": "Afficher les r\u00e9solutions",
        "conference_troubleshoot_aspectratio": "Afficher le rapport hauteur \/ largeur",
        "conference_troubleshoot_hasspeakers": "Ce mat\u00e9riel dispose-t-il d'un haut-parleur ?",
        "conference_troubleshoot_foundspeaker": "Haut-parleurs identifi\u00e9s",
        "conference_troubleshoot_hasmicrophone": "Ce mat\u00e9riel dispose-t-il d'un microphone ?",
        "conference_troubleshoot_foundmicrophone": "Microphones identifi\u00e9s",
        "conference_troubleshoot_haswebcam": "Ce mat\u00e9riel dispose-t-il d'une cam\u00e9ra ?",
        "conference_troubleshoot_foundcameras": "Cam\u00e9ras identifi\u00e9es",
        "conference_troubleshoot_webcampermission": "Le site web autorise-t-il l'usage d'une webcam?",
        "conference_troubleshoot_microphonepermission": "Le site web a-t-il acc\u00e8s \u00e0 un microphone ?",
        "conference_troubleshoot_getUsermedia": "Le navigateur permet d'acc\u00e9der \u00e0 getUserMedia sur cette page ?",
        "conference_troubleshoot_changeoutput_audiodevice": "Pouvez-vous changer les appareils audio ?",
        "conference_troubleshoot_changecamera_resolution": "Pouvez-vous changer les r\u00e9solutions des cam\u00e9ras sans faire une nouvelle demande de r\u00e9union ?",
        "conference_troubleshoot_supportwebrtc": "Le navigateur supporte WebRTC (soit 1.0 ou 1.1) ?",
        "conference_troubleshoot_supportortc": "Le navigateur prend en charge l'ORTC (WebRTC 1.1) ?",
        "conference_troubleshoot_turnserver": "Le serveur TURN est-il accessible ?",
        "conference_troubleshoot_turn": "turn:139.59.64.172:443",
        "conference_troubleshoo_coturn": "turn:coturn.instavc.com:443",
        "conference_troubleshoot_replacetracks": "Pouvez-vous remplacer les pistes sans ren\u00e9gocier les pairs ?",
        "conference_troubleshoot_record_remoteaudio": "Votre navigateur peut-il enregistrer un flux audio distant ou traiter un flux audio distant dans l'API WebAudio",
        "conference_troubleshoot_browsersupports_websocketapi": "Les navigateurs prennent en charge l'API WebSockets",
        "conference_troubleshoot_blockwebsocket": "Votre syst\u00e8me a bloqu\u00e9 le protocole WebSockets ou le serveur WebSockets n'est pas accessible ? Non",
        "conference_troubleshoot_supportwebaudioapi": "Le navigateur prend-il en charge l'API WebAudio ?",
        "conference_troubleshoot_supportsctp": "Le navigateur prend en charge les canaux de donn\u00e9es SCTP ?",
        "conference_troubleshoot_supportsrtp": "Le navigateur prend en charge les canaux de donn\u00e9es RTP ?",
        "conference_troubleshoot_support_screencapturing": "Cette page prend-elle en charge l'API de capture d'\u00e9cran ?",
        "conference_troubleshoot_support_multimonitor": "Le navigateur permet-il de s\u00e9lectionner et de capturer l'\u00e9cran de plusieurs moniteurs ?",
        "conference_troubleshoot_mobiledevice": "Utilisez-vous un appareil mobile ?",
        "conference_troubleshoot_supportscreencap_canvas": "Le navigateur prend-il en charge la capture d'\u00e9cran \u00e0 partir d'un canevas ?",
        "conference_troubleshoot_supportscreencap_video": "Le navigateur supporte-t-il la capture d'\u00e9cran \u00e0 partir d'une vid\u00e9o ?",
        "conference_troubleshoot_supportpromisses": "Le navigateur permet-il de r\u00e9aliser des traitements de fa\u00e7on asynchrone ( JS Promises )?",
        "conference_troubleshoot_ipaddress": "Cliquez pour afficher les adresses IP",
        "conference_troubleshoot_stunserver": "Le serveur STUN est-il accessible ?",
        "conference_troubleshoot_cancel": "Annuler",
        "instavc_conference_revoke_fromhost": "R\u00e9vocation de l'organisateur",
        "instavc_conference_startvideoconf_button": "D\u00c9MARRER LA VID\u00c9OCONF\u00c9RENCE",
        "instavc_conference_loading": "chargement de votre \u00e9cran, veuillez patienter",
        "instavc_conference_authenticating": "Authentification dans le serveur Instavc ....",
        "instavc_conference_joinconference": "Rejoindre la r\u00e9union",
        "instavc_conference_publishyourvideo": "Publier votre vid\u00e9o",
        "instavc_conference_publishyouraudio": "Publier votre audio",
        "instavc_conference_settings": "Param\u00e8tres",
        "instavc_conference_setting": "Param\u00e8tres de la r\u00e9union",
        "instavc_conference_setting_source": "Source",
        "instavc_conference_setting_camera": "Cam\u00e9ra",
        "instavc_conference_audioinputs": "Entr\u00e9es audio",
        "instavc_conference_setting_cancel": "ANNULER",
        "instavc_conference_setting_apply": "APPLIQUER",
        "instavc_conference_setting_resolution": "RESOLUTION",
        "instavc_conference_setting_qr": "QR(BETA)",
        "instavc_conference_whiteboard": "Tableau blanc",
        "instavc_conference_screenshare": "Partage d'\u00e9cran",
        "instavc_conference_presenter": "Pr\u00e9sentateur",
        "instavc_conference_stopshare": "Arr\u00eater le partage",
        "instavc_conf_install_Screenshare": "Installer ScreenShare",
        "instavc_conference_videosync": "Sync vid\u00e9o",
        "instavc_conference_videourl": "URL de la vid\u00e9o",
        "instavc_conference_enter_videourl": "Entrez l'URL de la vid\u00e9o",
        "instavc_conference_videourl_note": "Note : Seuls les participants actifs peuvent regarder cette vid\u00e9o, les retardataires ne peuvent pas voir la vid\u00e9o",
        "instavc_conf_recordings": "Enregistrement",
        "instavc_conference_sharecontent": "Partagez votre \u00e9cran",
        "instavc_conference_sharecontent_screen": "connect.instavc.com veut partager le contenu de votre \u00e9cran. Choisissez ce que vous souhaitez partager",
        "instavc_conference_shareentire_screen": "Votre \u00e9cran complet",
        "instavc_conference_sharescreen_applicationwindow": "Fen\u00eatre de l'application",
        "instavc_conference_sharescreen_chrometab": "Onglet Chrome",
        "instavc_conference_sharescreen_cancel": "Annuler",
        "instavc_conference_sharescreen_share": "Partager",
        "instavc_conf_sharescreen": "Vous partagez votre \u00e9cran !",
        "instavc_conf_share_otherparticipants": "Les autres participants peuvent voir les demandes et les documents sur votre \u00e9cran",
        "instavc_stopsharing": "Arr\u00eatez le partage",
        "instavc_conference_chat": "Chat",
        "instavc_conference_additional_camera": "Cam\u00e9ra suppl\u00e9mentaire",
        "instavc_conference_sharescreen_groupchat": "Groupe de Chat",
        "instavc_conference_sharescreen_GC": "GC",
        "instavc_conference_entermessage": "Dites quelque chose !",
        "instavc_conference_adddevice": "Ajouter des mat\u00e9riels",
        "instavc_conference_adddevice_addcamera": "Ajouter un appareil photo",
        "instavc_conference_adddevice_source": "SOURCE",
        "instavc_conference_adddevice_camera": "Cam\u00e9ra",
        "instavc_conference_adddevice_cameraname": "Cam\u00e9ra HD FaceTime",
        "instavc_conference_adddevice_close": "FERMER",
        "instavc_conference_adddevice_publish": "PUBLIER",
        "instavc_conference_info": "info",
        "instavc_conference_questions": "Questions",
        "instavc_conference_askquestions": "Poser des questions",
        "instavc_conference_info_meetingid": "Identifiant de la r\u00e9union",
        "instavc_conference_fullscreen": "Plein \u00e9cran",
        "conference_setup_invitepeoplel": "Inviter des personnes",
        "conference_setup_invite_linktojoin": "https:\/\/connect.instavc.com\/conference-guest\/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7\/f",
        "conference_setup_invite_byemail": "Invitation par email",
        "instavc_conference_participants": "participants",
        "instavc_conference_participants_search": "Rechercher ...",
        "instavc_conference_participant": "Participant",
        "instavc_conference_participants_muteall": "Mettez tout en sourdine",
        "instavc_conference_participants_unmuteall": "UnMute All",
        "instavc_conference": "R\u00e9union",
        "instavc_conf_more": "Pour en savoir plus",
        "instavc_conference_picturemode": "Cette vid\u00e9o est diffus\u00e9e en mode image-dans-l'image",
        "instavc_conference_mediastreams_stats": "Statistiques sur les flux de m\u00e9dias",
        "instavc_conference_mediastreams_audio": "Audio",
        "instavc_conference_mediastreams_audio_send": "Envoyer",
        "instavc_conference_mediastreams_audio_codec": "Codec",
        "instavc_conference_mediastreams_audio_rates": "Taux(Kbps)",
        "instavc_conference_mediastreams_audio_lost": "Perdu",
        "instavc_conference_mediastreams_audio_fraction": "Fraction",
        "instavc_conference_mediastreams_video": "Vid\u00e9o",
        "instavc_conference_mediastreams_video_send": "Envoyer",
        "instavc_conference_mediastreams_video_codec": "Codec",
        "instavc_conference_mediastreams_video_rates": "Taux(Kbps)",
        "instavc_conference_mediastreams_video_lost": "Perdu",
        "instavc_conference_mediastreams_video_fraction": "Fraction",
        "instavc_conference_resolution": "R\u00e9solution",
        "instavc_conference_framerate": "Fr\u00e9quence des images",
        "instavc_conference_nack": "Nack",
        "instavc_conference_pli": "PLI",
        "instavc_conference_bw": "BW disponible",
        "instavc_conference_audiomuted": "Audio d\u00e9sactiv\u00e9e",
        "instavc_conference_microphonemuted": "Votre micro est coup\u00e9",
        "join_conference_join_meetinginvitation": "R\u00e9unions ou vous \u00eates invit\u00e9s",
        "join_conference_search": "Rechercher ...",
        "join_conference_meeting details": "nom de la r\u00e9union\nInvit\u00e9 par :\nnom de l'invit\u00e9",
        "join_conference_join": "REJOINDRE",
        "join_conference_nomeetings": "Pas de r\u00e9unions",
        "join_conference_noupcomingmeetings": "Vous n'avez aucune invitation \u00e0 une r\u00e9union",
        "insta_conference_mycontacts": "Mes contacts",
        "insta_conference_search": "Rechercher ...",
        "insta_conference_typemessage": "Tapez un message",
        "insta_conference_addcontact": "Ajouter un contact",
        "insta_conference_enteremail": "Saisir l'email",
        "insta_conference_add": "AJOUTER",
        "insta_conference_nouserfound": "Aucun utilisateur n'a \u00e9t\u00e9 trouv\u00e9 avec cette adresse email",
        "instavc_conf_callnot_allowed": "Vous ne pouvez pas appeler d'autres utilisateurs lorsque vous \u00eates d\u00e9j\u00e0 en communication",
        "insta_conference_pendingapproval": "En attente d'approbation",
        "insta_conference_outgoingvideocall": "Appel vid\u00e9o sortant",
        "insta_conference_calling": "Appel en cours ....",
        "insta_conference_incomingvideocall": "Appel vid\u00e9o entrant",
        "insta_conference_calldecline": "D\u00e9cliner",
        "insta_conference_callaccept": "Accepter",
        "insta_conference_instavcalert": "connect.instavc.com veut permettre",
        "insta_conference_usemicrophone": "Utilisez votre micro",
        "insta_conference_usecamera": "Utilisez votre cam\u00e9ra",
        "insta_conference_blockdevices": "Bloc",
        "insta_conference_allowdevices": "Autoriser",
        "instavc_schedulemeeting_createmeeting": "Planifier une nouvelle r\u00e9union \/ Modifier",
        "instavc_schedulewebinar_createmeeting": "Cr\u00e9er un nouveau webinaire \/ Modifier",
        "instavc_schedulemeeting_meetingname": "Donnez un nom \u00e0 votre r\u00e9union",
        "instavc_schedulemeeting_selectnames_tomeeting": "Choisissez une salle pour votre r\u00e9union",
        "instavc_schedulemeeting_setduration": "Saisir la dur\u00e9e",
        "instavc_schedulemeeting_15min": "15 minutes",
        "instavc_schedulemeeting_30min": "30 minutes",
        "instavc_schedulemeeting_60min": "60 minutes",
        "instavc_schedulemeeting_setcustom": "Personnaliser",
        "instavc_schedulemeeting_customduration": "Dur\u00e9e personnalis\u00e9e",
        "instavc_schedulemeeting_minutes": "Minutes",
        "instavc_schedulemeeting_setconfpassword": "D\u00e9finissez un mot de passe pour acc\u00e9der la r\u00e9union",
        "instavc_schedulemeeting_typepassword": "Saisissez le mot de passe de votre r\u00e9union",
        "instavc_schedulemeeting_conferencecolor": "Attribuez une couleur \u00e0 votre ic\u00f4ne de r\u00e9union",
        "instavc_schedulemeeting_invitepeople": "Inviter des participants \u00e0 cette r\u00e9union",
        "instavc_schedulemeeting_search": "Rechercher ...",
        "instavc_schedulemeeting_SM": "SM",
        "instvc_SM_message": "Le nombre d'utilisateurs disposant d'une licence d'utilisateur autoris\u00e9 a d\u00e9pass\u00e9 la limite de la licence. Si vous souhaitez inviter plus de personnes, vous pouvez",
        "instavc_SM_message_href": "Achetez une licence",
        "instavc_schedulemeeting_notify": "Informer les participants \u00e0 cette r\u00e9union",
        "instavc_schedulemeeting_addreminder": "Ajouter des rappels",
        "instavc_schedulemeeting_add": "AJOUTER",
        "instavc_schedulemeeting_addmeetingreminder": "Ajouter un rappel de r\u00e9union",
        "instavc_schedulemeeting_adddatetime": "S\u00e9lecteur de date, s\u00e9lecteur d'heure",
        "instavc_schedulemeeting_cancel": "Annuler",
        "instavc_schedulemeeting_apply": "Appliquer",
        "instavc_schedulemeeting_name": "Veuillez saisir le nom de la r\u00e9union",
        "instavc_schedulemeeting_selectroom": "Veuillez s\u00e9lectionner la salle",
        "instavc_schedulemeeting_selectduration": "Veuillez choisir la dur\u00e9e",
        "instavc_recuring_schedule": "Planification r\u00e9currente",
        "instavc_schedulemeeting_nothinginreminders": "Rien dans les rappels",
        "instavc_schedulemeeting_createbutton": "CREER",
        "instavc_schedulemeeting_createdsuccessfully": "Planification cr\u00e9\u00e9e",
        "instavc_meetinglist_calender": "CALENDRIER",
        "instavc_meetinglist_selecteddates": "Vos dates choisies",
        "instavc_meetinglist_schedulecreted": "Planification cr\u00e9\u00e9e",
        "instavc_meetinglist_pastschedule": "Planification pr\u00e9c\u00e9dente",
        "instavc_meetinglist": "Liste des r\u00e9unions",
        "instavc_meetinglist_meetingdetils": "Nom de la r\u00e9union, heure de la r\u00e9union, Organis\u00e9e par",
        "instavc_meetinglist_search": "Rechercher ...",
        "instavc_meetinglist_deleterecuring": "Supprimer la planification r\u00e9currente",
        "instavc_meetinglist_alow_deleterecuring": "Souhaitez-vous supprimer uniquement l'horaire actuel ou tous les horaires de la r\u00e9currence ?",
        "instavc_meetinglist_schedule_series": "Tous les autres planifications de la s\u00e9rie resteront en place :",
        "instavc_meetinglist_schedule_seriesdelete": "Toutes les planifications de la s\u00e9rie seront supprim\u00e9s :",
        "instavc_meetinglist_allrecuringsch": "Toutes les planifications r\u00e9currents",
        "instavc_meetinglist_cancelchanges": "Annuler les modifications",
        "instavc_meetinglist_noschedules": "Aucune planification",
        "instavc_ml_schedulemessage": "Aucune planification de r\u00e9union n'a encore \u00e9t\u00e9 cr\u00e9\u00e9 !\nPlanifiez en une en cliquant sur le bouton ci-dessous.",
        "instavc_create_schedule": "Planifier une r\u00e9union",
        "instavc_meetinglist_currentschedule": "Planification actuel",
        "instavc_meetinglist_join": "REJOINDRE",
        "instavc_meetinglist_buynow": "ACHETER MAINTENANT",
        "instavc_dashboard_chooseplan": "Choisissez une offre",
        "instavc_package_smbplan": "Offres PME",
        "instavc_package_smbplan_host": "(Licence bas\u00e9e organisateur)",
        "instavc_package_smbplandescription": "Une salle ne peut avoir qu'un seul organisateur \u00e0 la fois. Un acheteur peut d\u00e9finir ou modifier le compte de l'organisateur, qui peut contr\u00f4ler la salle. Les acc\u00e8s aux organisateurs ne peuvent pas \u00eatre partag\u00e9s pendant la vid\u00e9oconf\u00e9rence. Tous les autres participants ne peuvent pas interagir avant que l'organisateur ne se joigne \u00e0 la r\u00e9union.",
        "instavc_package_basic": "De base",
        "instavc_package_hostuser_smb": "1 organisateur et",
        "instavc_package_hostuser_smb_users": "Participants",
        "instavc_package_currency": "$",
        "instavc_package_permonth": "\/ mois",
        "instavc_package_bill_smb": "Facturation annuelle",
        "instavc_package_include_smb": "L'offre comprend avec",
        "instavc_package_specifictions_Whiteboard": "Tableau blanc",
        "instavc_package_specifictions_Screen": "Partage d'\u00e9cran",
        "instavc_package_specifictions_nChat": "Chat",
        "instavc_package_specifictions_Recording": "Enregistrement",
        "instavc_package_specifictions_PresenterMode": "Mode pr\u00e9sentateur",
        "instavc_package_buynowbutton": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_smb": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_billinginfo": "Informations sur la facturation",
        "instavc_package_billinginfo_name": "Nom",
        "instavc_package_billinginfo_orginazation": "Entreprise",
        "instavc_package_biilinginfo_gstin": "GSTIN",
        "instavc_package_billinginfo_save": "ENREGISTRER",
        "instavc_package_billinginfo_edit": "Editer",
        "instavc_package_billingdetails": "D\u00e9tails de la facturation",
        "instavc_package_billingdetails_firstname": "Pr\u00e9nom",
        "instavc_package_billingdetails_lastname": "Nom",
        "instavc_package_billingdetails_address": "Adresse",
        "instavc_package_billingdetails_city": "Ville",
        "instavc_package_billingdetails_zip": "Zip",
        "instavc_package_billingdetails_cancel": "Annuler",
        "instavc_package_billingdetails_save": "ENREGISTRER",
        "instavc_package_shippinginfo": "Informations sur le transport",
        "instavc_package_shippinginfo_edit": "EDITER",
        "instavc_package_shippingdetails": "D\u00e9tails sur l'exp\u00e9dition",
        "instavc_package_shippingdetails_firstname": "Pr\u00e9nom",
        "instavc_package_shippingdetails_lastname": "Nom",
        "instavc_package_shippingdetails_address": "Adresse",
        "instavc_package_shippingdetails_city": "Ville",
        "instavc_package_shippingdetails_zip": "Zip",
        "instavc_package_shippingdetails_cancel": "Annuler",
        "instavc_package_shippingdetails_save": "ENREGISTRER",
        "instavc_package_cartsummary": "R\u00e9sum\u00e9 du panier",
        "instavc_package_hostbase": "Licence bas\u00e9e \u00e0 l'organisateur (Nom de la licence)",
        "instavc_package_smbplan_basic": "Offre PME - de base",
        "instavc_package_plandetails": "$ 144.02\n\nfactur\u00e9 pour 1 an\n13 $ par mois",
        "instavc_package_term": "Terme",
        "instavc_package_1year": "1 an",
        "instavc_package_2years": "2 ans",
        "instavc_package_3years": "3 ans",
        "instavc_package_4years": "4 ans",
        "instavc_package_5years": "5 ans",
        "instavc_package_subtotal": "Sous-total",
        "instavc_package_taxes": "Taxes et redevances (TPS +20%)",
        "instavc_package_launchoffer": "LANCEMENT",
        "instavc_package_promo": "La promotion a \u00e9t\u00e9 appliqu\u00e9e avec succ\u00e8s",
        "instavc_package_remove": "Supprimer",
        "instavc_package_havepromocode": "Vous avez un code de promotion ? Saisissez le ici",
        "instavc_package_entercouponcode": "Veuillez saisir un num\u00e9ro de coupon valide",
        "instavc_package_total": "Total",
        "instavc_package_offerdisclaimer": "Voir l'avertissement concernant l'offre",
        "instavc_package_paynow": "PAYEZ MAINTENANT",
        "instavc_package_payment_instavclicense": "PeopleLink Unified Communication\nPaiement de la licence InstaVC",
        "instavc_package_phone": "T\u00e9l\u00e9phone",
        "instavc_package_entervalid_contactnumber": "Veuillez entrer le num\u00e9ro de contact valide",
        "instavc_package_email": "Email",
        "instavc_package_enteremail": "Veuillez saisir un identifiant valide. Exemple : you@example.com",
        "instavc_package_paybycard": "PAYER PAR CARTE",
        "instavc_package_securedbyrazorpay": "S\u00e9curis\u00e9 par Razorpay",
        "instavc_package_card": "CARTE",
        "instavc_package_enterotp": "Saisir OTP envoy\u00e9 le xxxxxxxxx\npour acc\u00e9der aux cartes sauvegard\u00e9es",
        "instavc_package_resendotp": "Renvoi de l'OTP",
        "instavc_package_skipsavedcards": "Ignorer les cartes enregistr\u00e9es",
        "instavc_package_enter_otp": "Veuillez entrer l'otp",
        "instavc_package_skipthesavedcards": "Ignorer les cartes enregistr\u00e9es",
        "instavc_package_cardnumber": "Num\u00e9ro de la carte",
        "instavc_package_entervalid_cardnumber": "Veuillez entrer un num\u00e9ro de carte valide",
        "instavc_package_expiry": "Expiration",
        "instavc_package_cardholdername": "Nom du titulaire de la carte",
        "instavc_package_cvv": "CVV",
        "instavc_package_3digitcode": "Il s'agit d'un code \u00e0 3 chiffres imprim\u00e9 au dos de votre carte",
        "instavc_package_pay": "PAYER",
        "instavc_package_remembercard": "Carte de membre",
        "instavc_package_medium": "Moyen",
        "instavc_package_hostuser_medium": "1 organisateur et 50 participants",
        "instavc_package_month_medium": "15 $\/mois",
        "instavc_package_bill_medium": "Facturation annuelle + TPS 18",
        "instavc_package_include_medium": "L'offre comprend avec",
        "instavc_package_specifictions_medium": "Tableau blanc\nPartage d'\u00e9cran\nChat\nEnregistrement\nMode pr\u00e9sentateur",
        "instavc_package_buynow_medium": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_medium": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_advanced": "Avanc\u00e9",
        "instavc_package_hostuser_advanced": "1 organisateur et 100 participants",
        "instavc_package_month_advanced": "16 $\/ mois",
        "instavc_package_bill_advanced": "Facturation annuelle + TPS 18",
        "instavc_package_include_advanced": "L'offre comprend avec",
        "instavc_package_specifictions_advanced": "Tableau blanc\nPartage d'\u00e9cran\nChat\nEnregistrement\nMode pr\u00e9sentateur",
        "instavc_package_buynow_advanced": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_advanced": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_virtualmcu": "Licence MCU virtuelle",
        "instavc_package_virtualmcu_room": "(Licence bas\u00e9e \u00e0 la salle)",
        "instavc_package_vmcudetails": "Une salle ne peut avoir qu'un seul organisateur \u00e0 la fois. Un acheteur peut d\u00e9finir ou modifier le compte de l'organisateur, qui peut contr\u00f4ler la salle. Les acc\u00e8s aux organisateurs ne peuvent pas \u00eatre partag\u00e9s pendant la vid\u00e9oconf\u00e9rence. Tous les autres participants ne peuvent pas interagir avant que l'organisateur ne se joigne \u00e0 la r\u00e9union.",
        "instavc_package_instavc": "InstaVC",
        "instavc_package_silver": "Sliver",
        "instavc_package_userrooms_silver_users": "Participants",
        "instavc_package_userrooms_silver_rooms": "Salles",
        "instavc_package_month_silver": "281 $\/mois",
        "instavc_package_bill_silver": "Facturation annuelle + TPS 18",
        "instavc_package_include_silver": "L'offre comprend avec",
        "instavc_package_specifictions_silver": "Tableau blanc\nPartage d'\u00e9cran\nChat\nEnregistrement\nMode pr\u00e9sentateur",
        "instavc_package_buynow_silver": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_silver": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_gold": "Or",
        "instavc_package_userrooms_gold": "200 utilisateurs - 30 salles",
        "instavc_package_month_gold": "467 $\/ mois",
        "instavc_package_bill_gold": "Facturation annuelle + TPS 18",
        "instavc_package_include_gold": "L'offre comprend avec",
        "instavc_package_specifictions_gold": "Tableau blanc\nPartage d'\u00e9cran\nChat\nEnregistrement\nMode pr\u00e9sentateur",
        "instavc_package_buynow_gold": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_gold": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_platinum": "Platine",
        "instavc_package_userrooms_platinum": "500 participants - 50 salles",
        "instavc_package_month_platinum": "933 $\/ mois",
        "instavc_package_bill_platinum": "Facturation annuelle + TPS 18",
        "instavc_package_include_platinum": "L'offre comprend avec",
        "instavc_package_specifictions_platinum": "Tableau blanc\nPartage d'\u00e9cran\nChat\nEnregistrement\nMode pr\u00e9sentateur",
        "instavc_package_buynow_platinum": "ACHETER MAINTENANT",
        "instavc_package_fullfeatures_platinum": "ENSEMBLE DES FONCTIONNALIT\u00c9S",
        "instavc_package_legacybaselicense": "Licence ancienne",
        "instavc_package_licensebased_ports": "Licence bas\u00e9e sur le nombre de ports",
        "instavc_package_hardwareendpoint": "InstaVC avec terminal mat\u00e9riel",
        "instavc_package_webrtcconf_legacysupport": "R\u00e9union WebRTC avec des p\u00e9riph\u00e9riques anciens",
        "instavc_package_sip": "Support SIP \/ BFCP",
        "instavc_package_chh323": "Support ChH323 \/ H.239",
        "instavc_package_contactus": "CONTACTEZ-NOUS",
        "instavc_myprofile_dashboard": "Tableau de bord",
        "instavc_myprofile_settings": "Param\u00e8tres",
        "instavc_myprofile": "MON PROFIL",
        "instavc_myprofile_personaldetail": "Donn\u00e9es personnelles",
        "instavc_myprofile_personaldetails_name": "Nom",
        "instavc_myprofile_personaldetails_email": "Email",
        "instavc_myprofile_personaldetails_phoneno": "N\u00b0 de t\u00e9l\u00e9phone",
        "instavc_myprofile_personaldetails_address": "Adresse",
        "instavc_myprofile_personaldetails_city": "Ville",
        "instavc_myprofile_edit": "Editer",
        "instavc_myprofile_personaldetails": "Donn\u00e9es personnelles",
        "instavc_myprofile_firstname": "Pr\u00e9nom",
        "instavc_myprofile_lastname": "Nom de famille",
        "instavc_myprofile_email": "Email",
        "instavc_myprofile_phoneno": "N\u00b0 de t\u00e9l\u00e9phone",
        "instavc_myprofile_cancel": "Annuler",
        "instavc_myprofile_save": "Enregistrer",
        "instavc_myprofile_professionaldetails": "D\u00e9tails professionnels",
        "instavc_myprofile_position": "Position",
        "instavc_myprofile_professionaldetails_email": "Email",
        "instavc_myprofile_professionaldetails_phoneno": "N\u00b0 de t\u00e9l\u00e9phone",
        "instavc_myprofile_professionaldetails_address": "Adresse",
        "instavc_myprofile_professionaldetails_branch": "Succursale",
        "instavc_myprofile_professionaldetails_edit": "Editer",
        "instavc_myprofile_officialdetails": "D\u00e9tails officiels",
        "instavc_myprofile_officialdetails_position": "Position",
        "instavc_myprofile_officialdetails_email": "Email",
        "instavc_myprofile_officialdetails_phoneno": "N\u00b0 de t\u00e9l\u00e9phone",
        "instavc_myprofile_officialdetails_branch": "Succursale",
        "instavc_myprofile_officialdetails_address": "Adresse",
        "instavc_myprofile_officialdetails_cancel": "Annuler",
        "instavc_myprofile_officialdetails_save": "Enregistrer",
        "instavc_myprofile_contactinfo": "INFORMATION DE CONTACT",
        "instavc_myprofile_contactinformation": "Informations de contact",
        "instavc_myprofile_add": "AJOUTER",
        "instavc_myprofile_contactinformation_address": "Adresse",
        "instavc_myprofile_contactinformation_city": "Ville",
        "instavc_myprofile_contactinformation_zip": "Zip",
        "instavc_myprofile_contactinformation_landmark": "Point de rep\u00e8re",
        "instavc_myprofile_contactinformation_cancel": "Annuler",
        "instavc_myprofile_contactinformation_save": "ENREGISTRER",
        "instavc_myprofile_address": "Adresse",
        "instavc_myprofile_landmark": "Point de rep\u00e8re",
        "instavc_myprofile_delete": "Alerte",
        "instavc_myprofile_deletealert": "\u00cates-vous s\u00fbr de vouloir supprimer ceci ?",
        "instavc_myprofile_disagree": "D\u00c9SACCORD",
        "instavc_myprofile_agree": "ACCORD",
        "instavc_myprofile_websitelinks": "Lien vers le site web",
        "instavc_myprofile_website_add": "Ajouter",
        "instavc_myprofile_website": "Site web",
        "instavc_myprofile_websiteexample": "https:\/\/www.google.com",
        "instavc_myprofile_website_cancel": "Annuler",
        "instavc_myprofile_website_save": "Enregistrer",
        "instavc_myprofile_sociallinks": "Liens r\u00e9seaux sociaux",
        "instavc_myprofile_sociallinks_add": "AJOUTER",
        "instavc_myprofile_sociallink": "Liens sociaux",
        "instavc_myprofile_sociallinks_example": "https:\/\/www.facebook.com\/xxx",
        "instavc_myprofile_sociallink_cancel": "Annuler",
        "instavc_myprofile_sociallink_save": "Enregistrer",
        "instavc_myprofile_basicinfo": "Informations de base",
        "instavc_myprofile_basicinfo_add": "AJOUTER",
        "instavc_myprofile_basicinfo_dob": "Date de Naissance",
        "instavc_myprofile_basicinfo_gender": "Sexe",
        "instavc_myprofile_basicinformation": "Informations de base",
        "instavc_myprofile_basicinformation_dob": "Date de naissance",
        "instavc_myprofile_basicinformation_gender": "Sexe",
        "instavc_myprofile_basicinformation_cancel": "ANNULER",
        "instavc_myprofile_basicinformation_save": "Enregistrer",
        "instavc_myprofile_basicinformation_deletealert": "Alerte\n\u00cates-vous s\u00fbr de vouloir supprimer ceci ?",
        "instavc_myprofile_basicinformation_disagree": "D\u00c9SACCORD",
        "instavc_myprofile_basicinformation_agree": "ACCORD",
        "instavc_myprofile_uploadnewavatar": "T\u00c9L\u00c9CHARGER UN NOUVEL AVATAR",
        "instavc_myprofile_cropimage": "Recadrer l'image",
        "instavc_myprofile_image_cancel": "Annuler",
        "instavc_myprofile_image_save": "Enregistrer",
        "instavc_myprofile_locale": "LOCAL",
        "instavc_myprofile_localesettings": "Param\u00e8tres locaux",
        "instavc_myprofile_preferredlanguage": "Langue pr\u00e9f\u00e9r\u00e9e :",
        "instavc_myprofile_language": "Anglais",
        "instavc_settings": "Param\u00e8tres",
        "instavc_settings_changepassword": "CHANGER DE MOT DE PASSE",
        "instavc_settings_changepass": "Changer de mot de passe",
        "instavc_settings_currentpassword": "Saisissez le mot de passe actuel",
        "instavc_settings_newpassword": "Saisissez un nouveau mot de passe",
        "instavc_settings_changepassword_cancel": "ANNULER",
        "instavc_settings_changepassword_save": "ENREGISTRER",
        "instavc_settings_enter_currentpassword": "Veuillez saisir le mot de passe actuel",
        "instavc_settings_enter_newpassword": "Veuillez entrer le nouveau mot de passe",
        "instavc_settings_help": "Aide",
        "instavc_settings_affiliate": "Devenir Parrain",
        "instavc_settings_support": "Centre de support",
        "instavc_settings_newticket": "Ouvrir un nouveau ticket",
        "instavc_settings_ticketstatus": "V\u00e9rifier le statut des tickets",
        "instavc_settings_troubleshoot": "D\u00e9pannage",
        "instavc_legacy_dailout": "Appeler \u00e0 l'ext\u00e9rieur",
        "instavc_legacy_stats": "Stats",
        "instavc_legacy_dail_in_detail": "D\u00e9tails de l'appel",
        "instavc_legacy_h323_endpoint": "H.323 terminal",
        "instavc_legacy_sip_endpoint": "SIP terminal",
        "instavc_admin_users": "Utilisateurs",
        "instavc_admin_username": "Nom d'utilisateur",
        "instavc_admin_user_accountstatus": "\u00c9tat du compte",
        "instavc_admin_user_confirmed": "Confirm\u00e9",
        "instavc_admin_user_unconfirmed": "Non confirm\u00e9",
        "instavc_admin_user_resetall": "R\u00e9initialiser tout",
        "instavc_admin_user_sync": "Sync",
        "instavc_admin_user_status": "Statut",
        "instavc_admin_user_phonenumber": "Num\u00e9ro de t\u00e9l\u00e9phone",
        "instavc_admin_user_created": "Cr\u00e9\u00e9",
        "instavc_admin_user_all": "Tous",
        "instavc_admin_groups": "Groupes",
        "instavc_admin_addmore": "Ajouter plus",
        "instavc_admin_group_peoplelink": "Queens, GOLIVE, PeopleLink",
        "instavc_admin_select_plan": "Choisir un plan",
        "instavc_admin_lastmodified": "Derni\u00e8re modification",
        "instavc_admin_email_verified": "Email v\u00e9rifi\u00e9",
        "instavc_admin_verified": "V\u00e9rifi\u00e9",
        "instavc_admin_Unverified": "Non v\u00e9rifi\u00e9",
        "instavc_admin_licenses": "Licences",
        "instavc_admin_addlicense": "Ajouter des licences",
        "instavc_admin_defaultroom": "Chambre par d\u00e9faut",
        "instavc_admin_hostlicense": "Licence bas\u00e9e sur l'organisateur",
        "instavc_admin_roomlicense": "Licence bas\u00e9e sur la salle",
        "instavc_admin_virtualmcu": "Licence vMCU",
        "instavc_admin_enterprise": "Licence d'entreprise",
        "instavc_mcuserver": "Serveur MCU",
        "instavc_mculink": "https:\/\/awsmcu.instavc.com",
        "instavc_admin_expirydate": "Date d'expiration",
        "instavc_admin_settings": "Param\u00e8tres",
        "instavc_default_offer": "Offre de r\u00e9f\u00e9rence par d\u00e9faut",
        "instavc_enter_coupon_code": "Saisissez le code du coupon",
        "instavc_current_partshare": "Part du partenaire actuel",
        "instavc_share_value": "Valeur de la commission",
        "instavc_affliate_share": "Part des affili\u00e9s actuels",
        "instavc_enter_share": "Saisissez la valeur de la commission (%)",
        "instavc_roomname": "Nom de la salle",
        "instavc_room_ten": "Dix",
        "instavc_room_twenty": "Vingt",
        "instavc_room_thirty": "Trente",
        "instavc_room_hostbased": "Bas\u00e9 sur l'accueil",
        "instavc_virtualmcu": "MCU Virtuel",
        "instavc_rooms_enterprises": "Entreprise",
        "instavc_roomid": "ID de la chambre",
        "instavc_roomtype": "Type de salle",
        "instavc_room_options": "Options de salles",
        "instavc_commercialtype": "Type commercial",
        "instavc_free": "Gratuit",
        "instavc_poc": "POC",
        "instavc_commercial": "Commercial",
        "instavc_createdAt": "Cr\u00e9\u00e9 \u00e0",
        "instavc_useraccess": "Acc\u00e8s utilisateur",
        "instavc_peoplelinkroom": "Salle Peoplelink",
        "instavc_inputlimit": "Limite",
        "instavc_participant_limit": "Limite de participants",
        "instavc_adduser": "Ajouter un utilisateur",
        "instavc_searchbyname": "Recherche par nom",
        "instavc_manage_plans": "G\u00e9rer les offres\/produits",
        "instavc_new_plans": "Nouveau plan\/produit",
        "instavc_allplan_list": "Liste de toutes les tarifications",
        "instavc_sortby": "Trier par",
        "instavc_active": "Actif",
        "instavc_inactive": "Inactif",
        "instavc_create_plan": "Cr\u00e9er un nouveau plan",
        "instavc_plan_name": "Nom de l'offre",
        "instavc_enteramount": "Saisissez le montant (Min : INR 100)",
        "instavc_select_product": "S\u00e9lectionnez un produit",
        "instavc_host_room": "1 Organisateur \/ Salle",
        "instavc_multiroom": "Multi organisateurs \/ salles",
        "instavc_legacyrooms": "Ancien type de salle",
        "instavc_number_hosts": "Nombre d'organisateurs",
        "instavc_number_participants": "Nombre de participants",
        "instavc_number_room": "Nombre de salles",
        "instavc_subscriptiom_period": "P\u00e9riode d'abonnement",
        "instavc_sub_yearly": "Annuel",
        "instavc_sub_monthly": "Mensuel",
        "instavc_sub_weekly": "Semaine",
        "instavc_setinterval": "Fixer l'intervalle",
        "instavc_type": "Type",
        "instavc_subscription": "Abonnement",
        "instavc_onetime": "Une fois",
        "instavc_description": "Description",
        "instavc_planid": "Identifiant de l'offre",
        "instavc_orders": "Commandes",
        "instavc_orderid": "Identifiant de la commande",
        "instavc_none": "Aucune",
        "instavc_customer": "Client",
        "instavc_build_anually": "Construire annuellement",
        "instavc_recurring_billing": "Facturation r\u00e9currente",
        "instavc_next_due": "Prochaine \u00e9ch\u00e9ance pr\u00e9vue le",
        "instavc_invoice_details": "D\u00e9tail des factures",
        "instavc_recurring_payment": "Paiement r\u00e9current",
        "instavc_todays_sale": "Vente du jour",
        "instavc_total_order": "Total des commandes",
        "instavc_total_rooms": "Total des salles",
        "instavc_current_conference": "r\u00e9unions en cours",
        "instavc_current_user": "Utilisateurs actuels",
        "instavc_live_broadcast": "Diffusion en direct",
        "instavc_loading_chart": "Graphique en cours de chargement",
        "instavc_view": "Voir",
        "instavc_coupon_info": "Informations sur le coupon",
        "instavc_new_coupon": "Nouveau coupon",
        "instavc_create_coupon": "Cr\u00e9er un nouveau coupon",
        "instavc_coupon_code": "Code de coupon",
        "instavc_company_code": "Code de la compagnie",
        "instavc_select_plan": "S\u00e9lectionner les offres",
        "instavc_discount": "Remise",
        "instavc_activestatus": "activeStatus",
        "instavc_usage": "Utilisation",
        "instavc_activeusage": "activeusage",
        "instavc_singleuse": "Usage unique",
        "instavc_multiuse": "Usage multiple",
        "instavc_first_page": "Premi\u00e8re page",
        "instavc_previosu_page": "Page pr\u00e9c\u00e9dente",
        "instavc_next_page": "Page suivante",
        "instavc_last_page": "Derni\u00e8re page",
        "instavc_plan": "Offre",
        "instavc_request_withdrawal": "Demande de retrait",
        "instavc_withdraw": "Retrait",
        "instavc_account": "Compte",
        "instavc_verification": "V\u00e9rification",
        "instavc_withdraw_history": "Historique des retraits",
        "instavc_add_bank": "Ajouter un compte bancaire pour le retrait",
        "instavc_bank_description": "Nous prot\u00e9geons votre compte bancaire en pr\u00e9servant la confidentialit\u00e9 de vos informations financi\u00e8res. Pour \u00e9viter les \u00e9checs de retrait et le montant du remboursement, le nom figurant sur ce compte doit correspondre au nom figurant sur votre compte bancaire. Le transfert peut prendre un certain temps en fonction votre banque et des disponibilit\u00e9s de chacun",
        "instavc_bank_accountnumber": "Num\u00e9ro de compte bancaire",
        "instavc_enter_accountnumber": "Saisissez votre num\u00e9ro de compte",
        "instavc_account_name": "Nom du titulaire du compte",
        "instavc_per_bank_account": "Selon le compte bancaire",
        "instavc_ifsc": "Code IFSC",
        "instavc_bankname": "Nom de la banque",
        "instavc_branchname": "Nom de l'agence bancaire",
        "instavc_confirmdetails": "Confirmer les d\u00e9tails",
        "instavc_pandetails": "Veuillez fournir les d\u00e9tails ci-dessous en fonction de votre PAN",
        "instavc_enter_pan": "Saisissez votre nom selon le PAN",
        "instavc_fathername": "Nom du p\u00e8re",
        "instavc_enter_fathername": "Saisissez le nom de votre p\u00e8re",
        "instavc_pannumber": "Num\u00e9ro PAN",
        "instavc_panexampe": "Ex : BNZPM2501G",
        "instavc_upload_pan_copy": "T\u00e9l\u00e9charger une copie du PAN",
        "instavc_save_details": "Enregistrer les d\u00e9tails",
        "instavc_sales": "Ventes",
        "instavc_transactionid": "Identifiant de la transaction",
        "instavc_date": "Date",
        "instavc_amount": "Montant",
        "instavc_setaccount_withdraw": "Configurer les d\u00e9tails du compte avant un retrait",
        "instavc_first_withdraw": "Si vous faites une demande de retrait pour la premi\u00e8re fois, vous devez saisir les d\u00e9tails du compte et v\u00e9rifier votre compte dans les onglets suivants. Une fois la v\u00e9rification termin\u00e9e, vous pouvez demander un retrait du solde disponible.",
        "instavc_accountdetails": "Saisir les d\u00e9tails du compte",
        "instavc_available_balance": "Solde disponible",
        "instavc_amount_withdraw": "Montant \u00e0 retirer",
        "instavc_enteramount_withdraw": "Indiquez le montant que vous souhaitez retirer",
        "instavc_select_payment_mode": "Choisir le mode de paiement",
        "instavc_paypal_payment": "Paiement Paypal",
        "instavc_bank_transaction": "Transaction bancaire",
        "instavc_paypalfee": "Frais Paypal",
        "instavc_totalamount_withdraw": "Montant total \u00e0 retirer",
        "instavc_sendrequest": "Envoyer la demande",
        "instavc_no_request_withdraw": "Aucune demande de retrait n'a encore \u00e9t\u00e9 formul\u00e9e !",
        "instavc_start_process_withdraw": "Vous pouvez commencer le traitement du retrait comme suit.",
        "instavc_request_withdraw_now": "Demande de retrait imm\u00e9diat",
        "instavc_current_commission": "Commission actuelle",
        "instavc_from": "De",
        "instavc_to": "\u00c0 l'adresse suivante :",
        "instavc_today": "Aujourd'hui",
        "instavc_last7days": "Les 7 derniers jours",
        "instavc_lastmonth": "Ce mois-ci",
        "instavc_paid_customers": "Clients payants",
        "instavc_share_referral_link": "Partagez votre lien de parrainage avec vos amis",
        "instavc_copylink": "Copier le lien",
        "instavc_minimum_payout": "Paiement minimum",
        "instavc_referral_signup": "Parrains inscrits",
        "instavc_referral_clicks": "Clics de parrainage",
        "instavc_paid": "Pay\u00e9",
        "instavc_unpaid": "Non r\u00e9mun\u00e9r\u00e9",
        "instavc_totalearned": "Total gagn\u00e9",
        "instavc_myreferral": "Mes r\u00e9f\u00e9rences",
        "instavc_viewall": "Tout voir",
        "instavc_mysales": "Mes ventes",
        "instavc_sms_mfa": "Statut du SMS MFA",
        "instavc_facebook": "Facebook",
        "instavc_twitter": "Twitter",
        "instavc_linkedin": "LinkedIn",
        "instavc_referred_users": "Utilisateurs r\u00e9f\u00e9rents",
        "instavc_created_date": "CreatedDate",
        "instavc_myearnings": "Mes gains",
        "instavc_earnings": "Gains",
        "instavc_commission_share": "Part de la Commission",
        "instavc_commission_percentage": "Commission Pourcentage",
        "instavc_coupon_offers": "Coupons\/Offres",
        "instavc_my_referral_account": "Mon compte de parrainage",
        "instavc_req_withdraw": "Demande de retrait",
        "instavc_authenticating": "Authentification vers le serveur instaVC ...",
        "instavc_join_access_media": "Rejoint.. Acc\u00e8s aux dispositifs m\u00e9dias...",
        "instavc_publish_success": "Publier avec succ\u00e8s",
        "instavc_recieves": "Re\u00e7oit",
        "instavc_host_screenshare": "Vous devez devenir organisateur pour le partage d'\u00e9crans\/de documents ou",
        "instavc_request_sharescreen": "Demande d'acc\u00e8s pour le partage d'\u00e9cran \/ partage de documents",
        "instavc_note": "Note",
        "instavc_filesize": "La taille du fichier ne doit pas d\u00e9passer 10MB",
        "instavc_become_host": "Pour devenir  organisateur, cliquez sur l'icone en bas de la vid\u00e9o",
        "instavc_clicklink": "cliquez sur le lien Devenir Organisateur, dans la fen\u00eatre contextuelle et saisissez le mot de passe organisateur et cliquez sur le bouton Devenir un organisateur",
        "instavc_doc_share": "Partage de documents",
        "instavc_search_host": "En attente de l'organisateur",
        "instavc_wait_for_host": "Veuillez attendre que l'organisateur d\u00e9marre cette r\u00e9union",
        "instavc_open_black_dialog": "Ouvrir le dialogue noire",
        "instavc_open_white_dialog": "Ouvrir le dialogue blanc",
        "instavc_dail_detail": "Num\u00e9rotation - D\u00e9tails",
        "instavc_request_access": "Demande d'acc\u00e8s",
        "instavc_inordder_enable": "Afin de permettre",
        "instavc_host_permission": "vous devez obtenir une autorisation d'acc\u00e8s aupr\u00e8s de l'organisation",
        "instavc_please_wait": "Veuillez attendre",
        "instavc_host_to_permit": "Autorisation de l'organisateur pour",
        "instavc_alternate_content": "Contenu alternatif",
        "instavc_meeting_room": "Salle de r\u00e9union",
        "instavc_host_left_conference": "L'organisateur a quitt\u00e9 la r\u00e9union !",
        "instavc_conf_end": "La r\u00e9union se terminera automatiquement dans",
        "instavc_seconds": "Secondes",
        "instavc_waiting_msg": "Merci d'avoir attendu. Nous commencerons la r\u00e9union lorsque l'organisateur sera connect\u00e9",
        "instavc_let_hostname": "Vous voulez faire savoir \u00e0 l'organisateur que vous attendez ?",
        "instavc_exitconf": "Sortir de la r\u00e9union",
        "instavc_host_left": "L'organisateur a quitt\u00e9 la r\u00e9union...",
        "instavc_end_host_msg": "L'organisateur a mis fin \u00e0 cette r\u00e9union. Merci d'y avoir particip\u00e9.",
        "instavc_close_conf": "vous pouvez retourner \u00e0 l'accueil (ou) fermer l'application",
        "instavc_gohome": "Retourner \u00e0 la page d'accueil",
        "instavc_hand_raised": "Main lev\u00e9e",
        "instavc_ask": "Demandez \u00e0",
        "instavc_protocal": "Protocole",
        "instavc_bitrate": "Bitrate",
        "instavc_confirm_details": "Confirmez vos informations",
        "instavc_enter_info_conf": "Veuillez entrer vos identifiants avant de commencer la r\u00e9union.",
        "instavc_have_acc": "Si vous avez d\u00e9j\u00e0 un compte ?",
        "instavc_host_access": "Acc\u00e8s organisateur",
        "instavc_host_pass": "Saisissez le mot de passe de l'h\u00f4te",
        "instavc_becomehost": "Devenir organisateur",
        "instavc_permit_screenshare": "Autoriser le partage d'\u00e9cran",
        "instavc_allow_access": "Autoriser l'acc\u00e8s au tableau blanc",
        "instavc_request_permission": "a demand\u00e9 des autorisations suppl\u00e9mentaires pour",
        "instavc_deny": "Refuser",
        "instavc_customeremail": "Email du client",
        "instavc_orderlink": "Lien de commande",
        "instavc_customerid": "Identifiant du client",
        "instavc_selectpackage": "S\u00e9lectionner une offre",
        "instavc_host_package": "Licence bas\u00e9e sur l\u2019organisateur",
        "instavc_virtualbase_mcu": "Bas\u00e9 sur vMCU",
        "instavc_plans_product": "Offres\/Produits",
        "instavc_nodata": "Aucune donn\u00e9e disponible",
        "instavc_nodata_msg": "Il n'y a pas de donn\u00e9es disponibles pour le moment.",
        "instavc_basicplan": "Tarification Basic",
        "instavc_host_participants": "1 organisateur avec 30 participants",
        "instavc_link": "Lien",
        "instavc_cancel_order": "Annuler la commande",
        "instavc_per": "par",
        "instavc_user_email": "Courriel de l'utilisateur",
        "instavc_owner": "Propri\u00e9taire",
        "instavc_user": "Utilisateur",
        "instavc_default_users": "Offres par d\u00e9faut",
        "instavc_system_settings": "Param\u00e8tres de l'ordinateur",
        "instavc_expires": "Expire",
        "instavc_start_VC": "D\u00c9MARRER LA VID\u00c9OCONF\u00c9RENCE",
        "instavc_start_AC": "D\u00e9marrer l'audioconf\u00e9rence",
        "instavc_date_error": "La date et l'heure de d\u00e9but doivent \u00eatre sup\u00e9rieures \u00e0 l'heure actuelle",
        "instavc_browser_update": "Mise \u00e0 jour du navigateur requise",
        "instavc_browser_note": "Nous avons remarqu\u00e9 que vous utilisez une ancienne version de BROWSERNAME qui n'est plus support\u00e9e.",
        "instavc_browser_msg": "Instavc.com n\u00e9cessite une version actualis\u00e9e de BROWSERNAME ou de tout autre navigateur moderne.",
        "instavc_browser_upgrade": "Veuillez mettre \u00e0 jour votre navigateur avec la derni\u00e8re version disponible pour une meilleure exp\u00e9rience.",
        "instavc_googlechrome": "Google Chrome",
        "instavc_gc_version74": "Version 74",
        "instavc_mfirefox": "Mozilla Firefox",
        "instavc_mff_version": "Version 66",
        "instavc_opera": "Op\u00e9ra",
        "instavc_opera_version": "Version 60.0+",
        "instavc_microsoftedge": "Microsoft Edge",
        "instavc_ms_version": "Version 44",
        "instavc_safari": "Safari (Apple)",
        "instavc_safari_version": "Version 12.1",
        "instavc_contact_msg": "D\u00e9j\u00e0 mis \u00e0 niveau mais toujours un probl\u00e8me ? Contactez-nous \u00e0 l'adresse suivante",
        "instavc_camera_busy": "La cam\u00e9ra semble \u00eatre occup\u00e9e !",
        "instavc_close_camera": "Veuillez fermer toutes les applications et r\u00e9essayer.",
        "instavc_resolution": "R\u00e9solution non soutenue !",
        "instavc_camera_notsupport": "Votre cam\u00e9ra ne supporte pas cette r\u00e9solution.",
        "instavc_camera_reconfig": "Reconfigurez vos param\u00e8tres avec une r\u00e9solution plus faible et essayez \u00e0 nouveau.",
        "instavc_change_resolution": "Changer de R\u00e9solution",
        "instavc_confirmation": "Confirmation",
        "instavc_yes": "Oui",
        "instavc_delete_room": "Vous voulez vraiment supprimer la salle ?",
        "instavc_delete_license": "Voulez-vous vraiment supprimer la licence ?",
        "instavc_help": "Nous sommes l\u00e0 pour vous aider",
        "instavc_browse_questions": "Parcourez les questions les plus fr\u00e9quemment pos\u00e9es.",
        "instavc_os": "Syst\u00e8me d'exploitation",
        "instavc_macos": "Version Mac OS X :",
        "instavc_chrome_version": "Version Chrome :",
        "instavc_private_browsing": "Navigation priv\u00e9e ?",
        "instavc_faq_no": "Non",
        "instavc_display_resolution": "instavc_display_resolution",
        "instavc_aspect_ratio": "Afficher le rapport hauteur \/ largeur",
        "instavc_sys_hasspeakers": "Votre ordinateur a-t-il des haut-parleurs ?",
        "instavc_found_speakers": "Nombre de haut-parleurs trouv\u00e9s : 2",
        "instavc_speakers1": "Intervenant 1",
        "instavc_speakers2": "Intervenant 2",
        "instavc_sys_have_microphone": "L'ordinateur a-t-il un microphone ?",
        "instavc_found_microphone": "Nombre de microphones trouv\u00e9s : 2",
        "instavc_microphone1": "Microphone 1",
        "instavc_microphone2": "Microphone 2",
        "instavc_has_webcam": "Votre dispositif a-t-il une webcam ?",
        "instavc_found_speakers1": "Nombre  de haut-parleurs trouv\u00e9s : 1",
        "instavc_camera1": "Cam\u00e9ra 1",
        "instavc_webcam_permission": "Le site web a-t-il l'autorisation d'acc\u00e9der aux webcams ?",
        "instavc_microphone_permission": "Le site web est-il autoris\u00e9 a utiliser un microphone ?",
        "instavc_browser_allows": "Le navigateur permet-il d'acc\u00e9der \u00e0 getUserMedia sur cette page ?",
        "instavc_change_output_device": "Pouvez-vous changer les appareils restitution audio ?",
        "instavc_change_camera_resolutions": "Pouvez-vous changer les r\u00e9solutions des cam\u00e9ras sans faire de nouvelle demande de getUserMedia ?",
        "instavc_browser_support_webrtc": "Le navigateur supporte WebRTC (soit 1.0 ou 1.1) ?",
        "instavc_browser_support_ortc": "Le navigateur prend en charge le CTRO (WebRTC 1.1) ?",
        "instavc_initial_setup": "Veuillez patienter pendant que votre param\u00e9trage est en cours de traitement !",
        "instavc_close_browser": "Ne fermez pas votre navigateur et n'utilisez pas le bouton \"Pr\u00e9c\u00e9dent\" pour le moment.",
        "instavc_whoops": "D\u00e9sol\u00e9!",
        "instavc_nonet_msg": "Aucune connexion Internet trouv\u00e9e. Veuillez v\u00e9rifier votre connexion et r\u00e9essayer.",
        "instavc_nosearch": "Aucun r\u00e9sultat trouv\u00e9",
        "instavc_noserchmsg": "Nous ne trouvons aucun article correspondant \u00e0 votre recherche.",
        "instavc_nosearch_filter": "Essayez d'ajuster votre recherche ou votre filtre pour trouver ce que vous cherchez.",
        "instavc_gotohoem_page": "Aller \u00e0 la page d'accueil",
        "instavc_pageloading": "Chargement de la page en cours... Attendez s'il vous pla\u00eet !",
        "instavc_process": "Traitement...",
        "instavc_session_timeout": "Session arr\u00e9t\u00e9e",
        "instavc_session_inactivity": "Votre session est interrompue pour cause d'inactivit\u00e9.",
        "instavc_session_msg": "Veuillez choisir de rester connect\u00e9.",
        "instavc_session_reconnect": "Reconnectez-vous",
        "instavc_site_notreached": "Ce site n'est pas accessible !",
        "instavc_site_webaddress": "Assurez-vous que vous avez la bonne adresse web",
        "instavc_check_internet": "V\u00e9rifiez votre r\u00e9seau",
        "instavc_search_url": "Recherchez l'URL dans un autre navigateur",
        "instavc_goto": "Aller \u00e0",
        "instavc_request_for_access": "Demande d'acc\u00e8s",
        "instavc_start_collabrate": "pour commencer \u00e0 collaborer avec le tableau blanc",
        "instavc_large_conference_mode": "Vous \u00eates en mode \"Grande r\u00e9union\", vous ne pouvez pas parler ou regarder les autres avant que l'h\u00f4te ne vous en donne la permission",
        "instavc_allow_participants": "Vous \u00eates en mode \"Grande r\u00e9union\", vous devez autoriser manuellement les participants \u00e0 prendre la parole",
        "instavc_buy_premium": "Achetez une licence pour d\u00e9bloquer et activer ces fonctionnalit\u00e9s",
        "instavc_alert_tryagain": "Quelque chose s'est mal pass\u00e9, veuillez r\u00e9essayer",
        "instavc_enter_name": "Saisissez votre nom",
        "instavc_confirm": "Confirmer",
        "instavc_ok": "Ok",
        "instavc_askquestion": "Poser une question...",
        "instavc_recieve": "Recevoir",
        "instavc_delay": "Retard(ms)",
        "instavc_audio_opus": "Audio\/opus",
        "instavc_video_vp8": "vid\u00e9o\/vp8",
        "instavc_browser_not_support_incall": "Votre navigateur ne prend pas en charge le changement de r\u00e9solution pendant l'appel !",
        "instavc_failed_toPublish": "La diffusion de la vid\u00e9o a \u00e9chou\u00e9",
        "instavc_publish_fail": "\u00c9chec de la publication",
        "instavc_video_cant_publish": "La vid\u00e9o ne peut pas \u00eatre publi\u00e9e, en raison du d\u00e9passement du nombre d'utilisateurs",
        "instavc_failed_joinConference": "Impossible de rejoindre la r\u00e9union",
        "instavc_mute_audio": "Vous ne pouvez pas mettre en sourdine ou d\u00e9sactiver le son si le son \u00e0 distance a \u00e9t\u00e9 coup\u00e9 par l'utilisateur manuellement",
        "instavc_remote_audio_muted": "Audio distante d\u00e9sactiv\u00e9e !",
        "instavc_enter_conferenceid": "Saisissez l'identifiant de la r\u00e9union",
        "instavc_share_screen": "Partage d'\u00e9cran",
        "instavc_sharing_your_screen": "Partager votre \u00e9cran...",
        "instavc_stop": "Stop",
        "instavc_back": "Retour",
        "instavc_choose_plan": "Choisissez l'offre qui vous convient dans la liste ci-dessous",
        "instavc_have_promotionalcode": "Vous avez un code promotionnel \/ un code partenaire ?",
        "instavc_contact_pricing": "Contactez-nous pour conna\u00eetre nos tarifications",
        "instavc_payment_failed": "\u00c9chec du paiement",
        "instavc_payment_error": "Malheureusement, une erreur s'est produite lors du traitement de votre paiement.",
        "instavc_contact_support": "Veuillez contacter notre \u00e9quipe de support si vous avez besoin d'aide.",
        "instavc_tryagain": "Essayer \u00e0 nouveau",
        "instavc_payment_success": "Paiement r\u00e9ussi",
        "instavc_thanks_for_payment": "Merci pour votre paiement !",
        "instavc_payment_processed": "Votre paiement a \u00e9t\u00e9 trait\u00e9 avec succ\u00e8s. Un re\u00e7u de paiement automatis\u00e9",
        "instavc_mail_sent": "sera envoy\u00e9 sous peu \u00e0 l'adresse email que vous avez enregistr\u00e9e",
        "instavc_goto_homepage": "Retour \u00e0 la page d'accueil",
        "instavc_want_toend_call": "Vous voulez mettre fin \u00e0 la r\u00e9union ?",
        "instavc_exit_window": "En fermant cette fen\u00eatre, vous quitterez le r\u00e9union. \u00cates-vous s\u00fbr de vouloir y mettre fin ?",
        "instavc_create_room": "Cr\u00e9er une salle",
        "instavc_userlimit": "Nombre limite d'utilisateurs",
        "instavc_edit_room": "Modifier la salle",
        "instavc_update": "Mise \u00e0 jour",
        "instavc_manage_license": "G\u00e9rer les licences",
        "instavc_package": "Offre",
        "instavc_no_of_rooms": "Nombre de chambres",
        "instavc_no_of_users": "Nombre d'utilisateurs",
        "instavc_purchasedOn": "Achet\u00e9 le",
        "instavc_expiredon": "Expir\u00e9 le",
        "instavc_or": "OU",
        "instavc_otherhost_email": "Si vous voulez faire de n'importe quel utilisateur un organisateur, entrez son adresse email.",
        "instavc_set_host_password": "D\u00e9finir le mot de passe de l'organisateur",
        "instavc_host_password": "Mot de passe organisateur",
        "instavc_access_room": "Qui d'autre peut acc\u00e9der \u00e0 cette salle ?",
        "instavc_select_user_host": "S\u00e9lectionnez un utilisateur dans la liste pour en faire un organisateur.",
        "instavc_prologin": "InstaVC Pro Login",
        "instavc_start": "D\u00e9marrer",
        "instavc_enter_website": "Veuillez saisir le nom du site Web",
        "instavc_enter_valid_email": "Veuillez saisir une adresse \u00e9lectronique valide",
        "instavc_enter_valid_phone": "Veuillez saisir le num\u00e9ro de t\u00e9l\u00e9phone valide",
        "instavc_field_required": "Ce champ est obligatoire",
        "instavc_invitedby": "Invit\u00e9 par",
        "instavc_storage": "Stockage",
        "affiliate_approve": "Approuv\u00e9",
        "affiliate_pending": "En attente",
        "affiliate_rejected": "Rejet\u00e9",
        "affiliate_user_status": "Statut de l'utilisateur",
        "commission_other": "Autres commissions",
        "add_commission": "Ajouter des commissions",
        "delete_commission": "Voulez-vous supprimer la commission",
        "update_commission": "Mise \u00e0 jour de la commission",
        "name": "Nom",
        "offer_value": "Valeur de l'offre",
        "cancel": "Annuler",
        "add": "Ajouter",
        "update": "Mettre \u00e0 jour",
        "affiliates": "Affili\u00e9s",
        "status": "Statut",
        "status_change_message": "Vous souhaitez modifier le statut ?",
        "approve": "Approuver",
        "reject": "Rejeter",
        "commissions": "Commissions",
        "withdraw_data": "Donn\u00e9e du retrait",
        "withdraw_amount": "Montant du retrait",
        "payment_method": "Mode de paiement",
        "payment_fee": "Montant du paiement",
        "total_amount_withdraw": "Montant total \u00e0 retirer",
        "total_earnings": "Total des gains",
        "pending_amount": "Montant en attente",
        "paid_amount": "Montant pay\u00e9",
        "unpaid_amount": "Montant non pay\u00e9",
        "requested_withdraw": "Montant du retrait demand\u00e9",
        "english": "Anglais",
        "french": "Fran\u00e7ais",
        "room": "Salle",
        "create": "Cr\u00e9er",
        "repeat": "R\u00e9p\u00e9ter",
        "daily": "Quotidien",
        "repeat_every": "R\u00e9p\u00e9tez chaque",
        "repeat_on": "R\u00e9p\u00e9ter sur",
        "repeat_by": "R\u00e9p\u00e9ter par",
        "ends": "Fin",
        "after": "Apr\u00e8s",
        "occurences": "occurrences",
        "on": "sur",
        "summary": "R\u00e9sum\u00e9",
        "repeats": "R\u00e9p\u00e9tition de",
        "withdraws": "Retraits",
        "every": "Tous les",
        "days": "jours",
        "weeks": "semaines",
        "months": "mois",
        "onday": "le jour",
        "years": "ans",
        "times": "fois",
        "until": "jusqu'\u00e0",
        "past_meeting_list": "Liste des r\u00e9unions termin\u00e9es",
        "organised_by": "Organis\u00e9 par",
        "delete": "Supprimer",
        "join": "Rejoindre",
        "to": "\u00e0",
        "enter_password": "Saisissez votre mot de passe",
        "submit": "Soumettre",
        "enter_passwordmessage": "Veuillez saisir le mot de passe",
        "delete_message": "Voulez-vous supprimer",
        "meeting_permanent": "se r\u00e9unir de fa\u00e7on permanente ?",
        "day": "Jour",
        "password_message": "le mot de passe est incorrect",
        "timezone": "Fuseau horaire",
        "by": "par",
        "weekdays": "[DIM, LUN, MAR, MER, JEU, VEN, SAM]",
        "allweek": "[\"dimanche\", \"lundi\", \"mardi\", \"mercredi\", \"jeudi\", \"vendredi\", \"samedi\"]",
        "day_month": "jour du mois",
        "day_week": "jour de la semaine",
        "week": "Semaine",
        "month": "Mois",
        "year": "Ann\u00e9e",
        "enterpassword": "Veuillez saisir votre nouveau mot de passe et confirmer",
        "passwordmessage": "Le mot de passe et le mot de passe de confirmation doivent \u00eatre identiques",
        "passwordupdate": "Mise \u00e0 jour du mot de passe r\u00e9ussie",
        "numeric": "[\"premier\", \"deuxi\u00e8me\", \"troisi\u00e8me\", \"quatri\u00e8me\", \"cinqui\u00e8me\"]",
        "verify_email": "V\u00e9rifiez votre adresse email",
        "confirm_code": "Code de confirmation",
        "verify_msg": "Veuillez v\u00e9rifier le code sur votre t\u00e9l\u00e9phone portable.",
        "verify": "V\u00e9rifier",
        "not_recieved": "Pas re\u00e7u ?",
        "resend_otp": "Renvoi de l'OTP",
        "start_browsing": "Commencer \u00e0 naviguer",
        "become_affiliate": "Devenir affili\u00e9",
        "affiliate": "Affili\u00e9",
        "verify_mobile": "V\u00e9rifiez le SMS re\u00e7u sur votre t\u00e9l\u00e9phone portable",
        "instavc_allow_DocumentAccess": "Autoriser le partage de documents",
        "camera_not_access": "La cam\u00e9ra n'est pas accessible pour l'une des raisons suivantes :",
        "camera_not_access_reason1 ": "Reconfigurez vos param\u00e8tres de cam\u00e9ra avec une r\u00e9solution plus faible et essayez \u00e0 nouveau.",
        "camera_not_access_reason2": "Votre cam\u00e9ra est utilis\u00e9e par une autre application. Veuillez fermer toutes les applications et r\u00e9essayer en cliquant sur le lien.",
        "asgnQue_Assign_Question ": "Attribuer un questionnaire",
        "asgnQue_assigned_question": "Questionnaire attribu\u00e9",
        "quslsit_assig_que_list\t": "Liste des questionnaires assign\u00e9s",
        "quslsit_question_lists\t": "Listes de questionnaires",
        "quslsit_search\t": "Rechercher ...",
        "quslsit_add_new_question ": "Ajouter un nouveau questionnaire",
        "quslsit_no_question_assign ": "Aucun questionnaire n'a encore \u00e9t\u00e9 attribu\u00e9 !",
        "quslsit_assign-new_ques": "Attribuer un nouveau questionnaire pour cliquer sur le bouton Attribuer un questionnaire ci-dessus",
        "mdl_quesnr_questionnaire": "Questionnaire",
        "mdl_quesnr_select_question": "S\u00e9lectionner le questionnaire",
        "mdl_quesnr_duration": "Dur\u00e9e",
        "mdl_quesnr_time_limit": "Limite de temps",
        "mdl_quesnr_show_results": "Afficher les r\u00e9sultats",
        "mdl_quesnr_cancel": "Annuler",
        "mdl_quesnr_save": "Enregistrer",
        "viewAsg_question_details": "D\u00e9tails du questionnaire",
        "viewAsg_content_group": "Groupe de contenus",
        "viewAsg_questions": "Questions",
        "viewAsg_question_list": "Liste des questionnaires",
        "viewAsg_list_assigned_ques": "Liste des questions assign\u00e9es :",
        "viewAsg_mins": "mins",
        "viewAsg_marks": "Points",
        "asgQues_5_Marks": "( 5 points )",
        "asgQues_answers": "R\u00e9ponses",
        "asgQues_no_questions": "Pas de questions !",
        "grdSet_GPA_calculation": "Calcul \u00e0 partir du pourcentage",
        "grdSet_GPA_cal_msg": "Le pourcentage est de 100 %, ce qui n'est rien d'autre que 100 points. Ainsi, 25 points de pourcentage \u00e9quivalent \u00e0 1 point dans le syst\u00e8me AMP. La formule de calcul du pourcentage dans la MPC consiste \u00e0 diviser votre pourcentage par 100 et \u00e0 le multiplier par 4. Si votre pourcentage est de 75 %, votre note sera de (75\/100)*4 = 3.",
        "grdSet_grade_point": "Si les notes sont",
        "mngGrd_grades": "Notes",
        "mngGrd_cancel": "Annuler",
        "mngGrd_save": "Enregistrer",
        "mngGrd_modify": "Modifier",
        "mngGrd_save_grades": "Sauvegarder les notes",
        "mngGrd_modify_grades": "Modifier les notes",
        "mngGrd_grade_info": "Informations sur les notes",
        "admnAns_answer_list": "Liste des r\u00e9ponses",
        "admnAns_answer_list_for_question": "Vous trouverez ci-dessous la liste des r\u00e9ponses \u00e0 l'ensemble du questionnaire inclus dans les documents de ce groupe",
        "admnAns_answered": "R\u00e9ponse :",
        "admnAns_correct_answer": "R\u00e9ponse correcte",
        "prtcpt_certification": "Certifications :",
        "prtcpt_other_content_group": "Dans d'autres groupes de contenus",
        "prtcpt_sales": "Ventes",
        "prtcpt_marketing": "Marketing",
        "prtcpt_human_resource": "Ressources humaines",
        "mngPrtcpt_participants": "participants",
        "mngPrtcpt_add_participants": "Ajouter des participants",
        "mngPrtcpt_participants_list": "Listes des participants",
        "mngPrtcpt_import_participants": "Importer des participants",
        "mngPrtcpt_download_sample": "T\u00e9l\u00e9charger l'\u00e9chantillon",
        "mngPrtcpt_no_participants_added": "Aucun participant n'a encore \u00e9t\u00e9 ajout\u00e9 !",
        "mngPrtcpt_add_new_participant": "Ajouter un nouveau participant, pour l'ajouter, cliquez sur le bouton Ajouter un participant ci-dessus",
        "addPrtcpt_select_participants": "S\u00e9lectionner les participants",
        "addPrtcpt_model_add_participants": "Ajouter des participants",
        "prtcptGrde_participant_grade": "D\u00e9tails sur les notes des participants",
        "prtcptGrde_grade_participants_list": "Liste des participants",
        "mngQuesnr_questionnaire_list": "Liste des questionnaires",
        "mngQuesnr_create_questionnaire": "Cr\u00e9er un questionnaire",
        "mngQuesnr_search": "Rechercher ...",
        "mngQues_question_details ": "D\u00e9tails du questionnaire",
        "mngQues_add_questions": "Ajouter des questions",
        "mngQues_question_list": "Liste des questionnaires",
        "mngQues_questions": "Questions",
        "mngQues_list_assign_question": "Liste des questions assign\u00e9es :",
        "mngQues_no_question_created": "Aucune question n'a encore \u00e9t\u00e9 cr\u00e9\u00e9e !",
        "mngQues_create_new_question": "Cr\u00e9er une nouvelle question, pour cr\u00e9er cliquez sur le bouton Cr\u00e9er une question ci-dessus",
        "mdlGrp_questionnaire": "Questionnaire",
        "mdlGrp_questionnaire_name": "Nom du questionnaire",
        "mdlGrp_description": "Description",
        "mdlGrp_cancel": "Annuler",
        "mdlGrp_update": "Modifier",
        "mdlGrp_create": "Cr\u00e9er",
        "mdlCrtQues_update_question": "Question de mise \u00e0 jour",
        "mdlCrtQues_create_questionnaire": "Cr\u00e9er un questionnaire",
        "mdlCrtQues_enter_question_here": "Saisissez votre question ici",
        "mdlCrtQues_marks": "Points",
        "mdlCrtQues_question_type": "Type de question",
        "mdlCrtQues_sel_question_type": "S\u00e9lectionnez le type de question",
        "mdlCrtQues_single_sel_multiple_choice": "Choix multiple \u00e0 s\u00e9lection unique",
        "mdlCrtQues_multiselect_multiple_choice": "Question \u00e0 choix multiple",
        "mdlCrtQues_ture_false": "Vrai\/Faux",
        "mdlCrtQues_enter_answer_choice": "Saisissez les choix de r\u00e9ponse et indiquez quelle r\u00e9ponse est la bonne",
        "mdlCrtQues_add_another_choice": "+ Ajouter un autre choix",
        "mdlCrtQues_cancel": "Annuler",
        "viewQues_questionnaire_details": "D\u00e9tails du questionnaire",
        "viewQues_add_questions": "Ajouter des questions",
        "viewQues_question_list": "Liste des questionnaires",
        "viewQues_question": "Questions",
        "viewQues_list_assign_questions": "Liste des questions assign\u00e9es :",
        "viewQues_no_question_created": "Aucune question n'a encore \u00e9t\u00e9 cr\u00e9\u00e9e !",
        "viewQues_create_new_question": "Cr\u00e9er une nouvelle question, pour cr\u00e9er cliquez sur le bouton Cr\u00e9er une question ci-dessus",
        "crteContent_create_new_content": "Cr\u00e9er un nouveau contenu",
        "crteContent_update_content": "Mettre \u00e0 jour le contenu",
        "crteContent_update": "Modifier",
        "crteContent_save_content": "Sauvegarder le contenu",
        "crteContent_save": "Enregistrer",
        "crteContent_content_group": "Groupe de contenus",
        "crteContent_content_list": "Listes de contenus",
        "crteContent_edit_content": "Modifier le contenu",
        "crteContent_create_content": "Cr\u00e9er du contenu",
        "crteContent_create_your_content_like": "Cr\u00e9ez votre contenu, en ajoutant des m\u00e9dias comme des images, des fichiers vid\u00e9o, des fichiers audio et des documents.",
        "crteContent_upload_document": "T\u00e9l\u00e9charger des documents",
        "crteContent_upload_media": "T\u00e9l\u00e9charger les m\u00e9dias",
        "crteContent_document": "Documents",
        "crteContent_media_files": "Fichiers m\u00e9dias",
        "viewCon_content_view": "Vue du contenu",
        "viewCon_content_group": "Groupe de contenus",
        "viewCon_content_list": "Listes de contenus",
        "viewCon_View_content": "Voir le contenu",
        "viewCon_enable": "Activer :",
        "viewCon_document": "Documents",
        "viewCon_media_files": "Fichiers m\u00e9dias",
        "viewCon_content": "Contenu",
        "conRow_enable": "Activer :",
        "conRow_by": "Par :",
        "conRow_content_group": "Groupe de contenus",
        "grpRow_enable": "Activer :",
        "grpRow_by": "Par :",
        "hozConNav_content": "Contenu",
        "hozConNav_participants": "participants",
        "hozConNav_grade": "Notes",
        "hozConNav_assign_questionnaire": "Attribuer un questionnaire",
        "mngCon_create_new_content": "Cr\u00e9er un nouveau contenu, pour cr\u00e9er cliquez sur le bouton Cr\u00e9er un contenu ci-dessus",
        "mngCon_all": "Tous",
        "mngCon_content_list": "Listes de contenus",
        "mngCon_no_content_created": "Aucun contenu n'a encore \u00e9t\u00e9 cr\u00e9\u00e9 !",
        "mdlAccRight_share_access": "Partager l'acc\u00e8s avec d'autres formateurs",
        "mdlAccRight_type_id_add": "Saisissez votre adresse \u00e9lectronique et cliquez sur ajoutez",
        "mdlAccRight_no_instructor_added": "Aucun formateur n'a encore \u00e9t\u00e9 ajout\u00e9 .",
        "mdlAccRight_add_people_from_addressbok": "Ajoutez des personnes de votre carnet d'adresses, ou en saisissant une adresse \u00e9lectronique.",
        "mdlAccRight_addressbook": "Carnet d'adresses",
        "mdlAccRight_search": "Rechercher ...",
        "mdlAccRight_contacts": "Contacts",
        "mdlAccRight_add_contacts": "Ajouter des contacts au groupe de contenu, \u00e0 partir des contacts de votre carnet d'adresses",
        "mdlAccRight_no_contacts_added": "Aucun contact n'a encore \u00e9t\u00e9 ajout\u00e9 .",
        "mdlAccRight_cancel": "Annuler",
        "mdlConfDel_confirmation": "Confirmation",
        "mdlConfDel_are_you_sure_delete": "\u00cates-vous s\u00fbr de vouloir supprimer cette",
        "mdlConfDel_cancel": "Annuler",
        "mdlConfDel_delete": "Supprimer",
        "mdlCrtConGrp_alert_enter_group_title": "Veuillez saisir le nom du groupe",
        "mdlCrtConGrp_alert_enter_group_description": "Veuillez saisir la description du groupe",
        "mdlCrtConGrp_content_group": "Groupe de contenus",
        "mdlCrtConGrp_group_name": "Nom du groupe",
        "mdlCrtConGrp_description": "Description",
        "mdlCrtConGrp_cancel": "Annuler",
        "mdlCrtConGrp_save": "Enregistrer",
        "mdlUpldoc_alert_enter_title_doc": "Veuillez saisir le titre du document",
        "mdlUpldoc_upload_document": "T\u00e9l\u00e9charger des documents",
        "mdlUpldoc_document_title": "Titre du document",
        "mdlUpldoc_upload_doc_from_system": "T\u00e9l\u00e9chargez un document depuis votre ordinateur, il supporte les formats .pdf, excel, word.",
        "mdlUpldoc_upload_doc": "T\u00e9l\u00e9charger le document",
        "mdlUpldoc_added_doc": "Documents ajout\u00e9s",
        "mdlUpldoc_cancel": "Annuler",
        "mdlUpldoc_save": "Enregistrer",
        "mdlUplMedia_alert_enter_title_media": "Veuillez saisir le titre du m\u00e9dia",
        "mdlUplMedia_alert_enter_title_url": "Veuillez saisir le titre et l'URL",
        "mdlUplMedia_alert_enter_youtube_vimeo_url": "Veuillez entrer une URL valide et (Youtube / Vimeo)",
        "mdlUplMedia_upload_media": "T\u00e9l\u00e9charger un m\u00e9dia",
        "mdlUplMedia_upload_url": "URL de t\u00e9l\u00e9chargement",
        "mdlUplMedia_Upload_media_system": "T\u00e9l\u00e9chargez un m\u00e9dia \u00e0 partir de votre syst\u00e8me, il supporte les formats .jpg, .png, .jpeg, .mp3, .mp4",
        "mdlUplMedia_add_media_url": "Ajouter l'adresse URL du m\u00e9dia pour joindre un m\u00e9dia",
        "mdlUplMedia_upload_media_url": "URL de t\u00e9l\u00e9chargement du m\u00e9dia",
        "mdlUplMedia_upload_youtube_url": "Note : T\u00e9l\u00e9chargez les URL de YouTube",
        "mdlUplMedia_Add_media_file": "Fichiers m\u00e9dias ajout\u00e9s",
        "mdlUplMedia_cancel": "Annuler",
        "mdlUplMedia_save": "Enregistrer",
        "mngContent_content": "Contenu",
        "mngContent_participants": "Participants",
        "mngContent_grade_settings": "Param\u00e8tres de notes",
        "mngContent_assign_questonnaire": "Attribuer un questionnaire",
        "content_all_content_group": "Tous les groupes de contenus",
        "content_create_new_group": "Cr\u00e9er un nouveau groupe en cliquant sur le bouton Cr\u00e9er un groupe ci-dessus",
        "content_search": "Rechercher ...",
        "content_no_group_created": "Aucun groupe n'a encore \u00e9t\u00e9 cr\u00e9\u00e9 !",
        "conList_questionnaire": "Questionnaire",
        "conList_view": "Voir",
        "conList_all_group": "Tous les groupes",
        "conList_content_list": "Listes de contenus",
        "conList_no_content_created": "Aucun contenu n'a encore \u00e9t\u00e9 cr\u00e9\u00e9 !",
        "grpList_all_content_group": "Tous les groupes de contenus",
        "grpList_no_group_created": "Aucun groupe n'a encore \u00e9t\u00e9 cr\u00e9\u00e9 !",
        "questnrList_questionnaire": "Questionnaire",
        "questnrList_questionnaire_list": "Liste des questionnaires",
        "questnrList_no_question_assign": "Aucun questionnaire n'a encore \u00e9t\u00e9 attribu\u00e9 !",
        "questnrList_marksz": "Points",
        "questnrList_mins": "mins",
        "queStepper_can't_skip": "Vous ne pouvez pas sauter une \u00e9tape qui n'est pas facultative.",
        "queStepper_marks": "Points",
        "queStepper_back": "Retour",
        "queStepper_next": "Suivant",
        "queStepper_finish": "Terminer",
        "queStepper_submit_next": "Soumettre & Suivant",
        "showCont_content_list": "Listes de contenus",
        "showCont_document": "Documents",
        "showCont_media_file": "Fichiers m\u00e9dias",
        "showCont_previous": "Pr\u00e9c\u00e9dent",
        "showCont_next": "Suivant",
        "showCont_have_completed_topic": "J'ai termin\u00e9 les sujets de ce contenu",
        "showMedia_back": "Retour",
        "showMedia_page": "Page",
        "showMedia_of": "de",
        "showMedia_next": "Suivant",
        "showMedia_previous": "Pr\u00e9c\u00e9dent",
        "showQues_questionnaire_list": "Liste des questionnaires",
        "showQues_question": "Questions",
        "showQues_marks": "Points",
        "showQues_min_left": "min restant",
        "showQues_completed_test": "Vous avez rempli le test dans ce questionnaire.",
        "showQues_go_back_content_group": "Retour au groupe de contenu",
        "showQues_list_assign_question": "Liste des questions assign\u00e9es :",
        "viewUserScore_view_score": "Voir le score",
        "viewUserScore_question_list": "Liste des questionnaires",
        "viewUserScore_question": "Questions",
        "viewUserScore_total_marks": "Total des points :",
        "viewUserScore_marks": "Points",
        "viewUserScore_scored_marks": "Points not\u00e9s :",
        "viewUserScore_GPA_score": "Votre score GPA :",
        "viewUserScore_answer_list": "Liste des r\u00e9ponses",
        "viewUserScore_below_list_of_answer": "Vous trouverez ci-dessous la liste des r\u00e9ponses \u00e0 l'ensemble du questionnaire inclus dans les documents de ce groupe",
        "viewUserScore_answered": "R\u00e9pondues",
        "viewUserScore_correct_answer": "R\u00e9ponse correcte",
        "confCancle_confirmation": "Confirmation",
        "confCancle_are_you_sure": "Etes-vous s\u00fbr ?",
        "confCancle_cancel": "Annuler",
        "confCancle_delete_user": "Supprimer un utilisateur",
        "confSche_are_you_sure_delete": "\u00cates-vous s\u00fbr de vouloir supprimer cet planification ?",
        "confSche_no": "Non",
        "pastMtnItem_rn": "RN",
        "pastMtnItem_room_name": "Nom de la salle",
        "pastMtnItem_webinar_list": "Liste des webinaires",
        "pastMtnItem_list_webinar": "Vous trouverez ci-dessous la liste des webinaires.",
        "pastMtnItem_today": "Aujourd'hui",
        "pastMtnItem_webinar_title_falls": "Le titre du webinaire tombe ici",
        "pastMtnItem_view": "Vue",
        "pastMtnItem_upcoming": "A venir",
        "schedules_upload_custom_banner": "T\u00e9l\u00e9chargez une banni\u00e8re personnalis\u00e9e pour votre webinaire.",
        "scheView_edit_content": "Modifier le contenu",
        "scheView_scheduled_by": "Programm\u00e9 par :",
        "scheView_delete": "Supprimer",
        "scheView_download_calander": "T\u00e9l\u00e9charger les r\u00e9unions planifi\u00e9es",
        "scheView_invite_participants": "Inviter les participants",
        "scheView_start_conference": "D\u00e9marrez la r\u00e9union",
        "scheView_event_details": "D\u00e9tails de l'\u00e9v\u00e9nement",
        "scheView_room_name": "Nom de la salle",
        "scheView_duration": "Dur\u00e9e",
        "scheView_minutes": "Minutes",
        "scheView_conference_password": "Mot de passe de la r\u00e9union",
        "scheView_settings": "Param\u00e8tres",
        "scheView_webinar_event": "Webinaire",
        "scheView_list_webinar": "Inscrivez ce webinaire sur instavc.com\/webinar et acceptez les inscriptions.",
        "scheView_guest_login_anonymous": "L'invit\u00e9 peut se connecter anonymement",
        "scheView_allow_invities": "Autoriser uniquement les invit\u00e9s \u00e0 se joindre \u00e0 la r\u00e9union",
        "scheView_enable_webinar_chat": "Activer le \"chat\" pendant le webinaire",
        "scheView_enable_hand_rise": "Autoriser la fonction Mains Lev\u00e9es dans le cadre d'un webinaire",
        "scheView_list_of_people_invited": "Voici la liste des personnes invit\u00e9es",
        "scheView_alert_err_to_join": "Erreur pour rejoindre la r\u00e9union",
        "webnrDtls_room_name": "Nom de la salle",
        "webnrDtls_upcoming_webinar_room": "Vous trouverez ci-dessous le prochain webinaire pour cette salle.",
        "webnrDtls_webinar_details": "D\u00e9tails du webinaire",
        "webnrDtls_webinar_list": "Liste des webinaires",
        "webnrDtls_webinar_title": "Titre du webinaire",
        "webnrDtls_webinar_title_falls": "Le titre du webinaire tombe ici",
        "webnrDtls_get_more_joining": "Pour en savoir plus, participez \u00e0 ce webinaire.",
        "webnrDtls_join_webinar": "Rejoignez le webinaire",
        "webnrList_room_name": "Nom de la salle",
        "webnrList_webinar_list": "Liste des webinaires",
        "webnrList_below_list_of_webinar": "Vous trouverez ci-dessous la liste des webinaires.",
        "webnrList_today": "Aujourd'hui",
        "webnrList_webinar_title_falls": "Le titre du webinaire tombe ici",
        "webnrList_view": "Vue",
        "webnrList_upcoming": "A venir",
        "addBook_address_book": "Carnet d'adresses",
        "addBook_contact": "Contacts",
        "addBook_add_contact_to_meeting": "Ajouter des contacts \u00e0 la r\u00e9union, \u00e0 partir des contacts de votre carnet d'adresses",
        "meetingList_past_meetings": "R\u00e9unions termin\u00e9es",
        "meetingList_past_meetings_list": "Liste des r\u00e9unions termin\u00e9es",
        "meetingList_participants": "participants",
        "meetingList_room_name": "Nom de la salle :",
        "meetingList_view_content": "Voir le contenu",
        "meetingList_recording": "Enregistrements",
        "meetingList_view": "Voir",
        "scheInvt_err_invalid_id": "Identifiant email invalide",
        "scheInvt_invite_participants": "Inviter les participants",
        "scheInvt_address_book": "Carnet d'adresses",
        "scheInvt_invite_people_to_meeting": "Invitez des personnes \u00e0 cette r\u00e9union. Ajoutez des personnes de votre carnet d'adresses, ou en saisissant l'adresse Email ci-dessous et en cliquant sur\" Ajouter\".",
        "scheInvt_start": "Commence @",
        "scheInvt_below_list_of_answer": "Vous trouverez ci-dessous la liste des r\u00e9ponses \u00e0 l'ensemble du questionnaire inclus dans les documents de ce groupe",
        "scheInvt_room_name": "Nom de la salle :",
        "scheInvt_host": "Organisateur :",
        "scheInvt_minutes": "Minutes",
        "scheInvt_add": "Ajouter",
        "scheInvt_no_participants_added": "Aucun participant ajout\u00e9",
        "scheInvt_add_ppl_to_meetings": "Ajoutez des personnes \u00e0 cette r\u00e9union en tant que participants \u00e0 partir de votre carnet d'adresses, ou ajoutez-les ci-dessus et cliquez sur \"Ajouter\".",
        "scheInvt_cancel": "Annuler",
        "scheInvt_send_invitation": "envoyer une invitation",
        "scheInvt_send_passcodes": "Envoyez les codes d'acc\u00e8s dans un email s\u00e9par\u00e9 de l'invitation",
        "scheMeet_room_reserved_from": "Salle r\u00e9serv\u00e9e \u00e0 partir de",
        "scheMeet_meeting_name": "avec le nom de la r\u00e9union",
        "invitBody_invite_only_upto": "Vous ne pouvez inviter qu'un maximum de 10 participants",
        "invitBody_invite_ppl_meeting_email_add": "Invitez des participants \u00e0 cette r\u00e9union, ajoutez des participants depuis votre carnet d'adresses, ou ajoutez l'email.",
        "invitBody_copy": "Copier",
        "invitBody_enter_emailid": "Entrez votre adresse email",
        "invitBody_add": "Ajouter",
        "invitBody_close": "Fermer",
        "invitBody_send_invitation": "envoyer une invitation",
        "docShare_doc_sharing": "Partage de document",
        "docShare_upload_doc_system_pdf": "T\u00e9l\u00e9chargez un document depuis votre ordinateur, il supporte les formats .pdf, excel, word.",
        "docShare_upload_doc": "T\u00e9l\u00e9charger le document",
        "docShare_no_doc": "Pas de document",
        "docShare_no_doc_in_list": "Aucun document n'a encore \u00e9t\u00e9 ajout\u00e9 \u00e0 la liste.",
        "docShare_add_doc": "Documents ajout\u00e9s",
        "docShare_alert_title_doc": "Veuillez saisir le titre du document",
        "docShare_alert_something_went_wrong": "un probl\u00e8me est survenu, veuillez r\u00e9essayer",
        "docShare_alert_try_again": "veuillez r\u00e9essayer",
        "permitDocShr_permit_doc_share_access": "Permettre l'acc\u00e8s au partage de documents",
        "permitDocShr_req_permission_doc_share": "a demand\u00e9 l'autorisation d'acc\u00e9der au partage de documents.",
        "permitDocShr_deny": "Refuser",
        "permitDocShr_allow": "Autoriser",
        "reqDocShr_req_doc_share_access": "Demande d'acc\u00e8s au partage de documents",
        "reqDocShr_access_permission_host": "Pour activer le partage de documents, vous devez obtenir une autorisation d'acc\u00e8s aupr\u00e8s de l'organisateur",
        "reqDocShr_plz_wait": "Veuillez attendre",
        "reqDocShr_permission_start_doc_share": "(Organisateur) a autoris\u00e9 le partage de documents.",
        "reqDocShr_cancel": "Annuler",
        "reqDocShr_doc_share": "Partagez vos documents !",
        "showDocViewback": "Retour",
        "showDocViewdoc_title_name": "Titre du document Nom",
        "showDocViewnext": "Suivant",
        "showDocViewprevious": "Pr\u00e9c\u00e9dent",
        "showDocViewpage_of": "page de",
        "borcstScreen_alert_unsupported": "Format non support\u00e9. Les formats support\u00e9s sont webrtc et hls. Utilisez quelque chose comme playOrder=webrtc hls",
        "borcstScreen_alert_no_stream_spec": "Aucun flux n'est sp\u00e9cifi\u00e9. Veuillez ajouter ?id={STREAM_ID} \u00e0 l'URL",
        "borcstScreen_Plz_enable_js": "Pour visionner cette vid\u00e9o, veuillez activer JavaScript et envisager de passer \u00e0 un navigateur web qui",
        "borcstScreen_support_HTML5": "supporte la vid\u00e9o HTML5",
        "borcstScreen_steam_play_when_live": "Le flux vid\u00e9o sera diffus\u00e9e en direct",
        "broadcast_alert_unsupported": "Format non support\u00e9. Les formats support\u00e9s sont webrtc et hls. Utilisez quelque chose comme playOrder=webrtc hls",
        "broadcast_alert_no_stream_spec": "Aucun flux n'est sp\u00e9cifi\u00e9. Veuillez ajouter ?id={STREAM_ID} \u00e0 l'URL",
        "broadcast_enter_your_name": "Veuillez saisir votre nom",
        "broadcast_enter_your_email": "Veuillez entrer votre adresse \u00e9lectronique",
        "broadcast_user_details": "D\u00e9tails de l'utilisateur",
        "broadcast_submit_next": "Soumettre",
        "broadcast_Plz_enable_js": "Pour visionner cette vid\u00e9o, veuillez activer JavaScript et envisager de passer \u00e0 un navigateur web qui",
        "broadcast_support_HTML5": "supporte la vid\u00e9o HTML5",
        "broadcast_steam_play_when_live": "Le flux vid\u00e9o sera diffus\u00e9 en direct",
        "brdcstConf_whiteboard": "Tableau blanc",
        "brdcstConf_screen_share": "Partage d'\u00e9cran",
        "brdcstConf_participants": "participants",
        "brdcstConf_broadcast": "Diffusion",
        "brdcstConf_cancel": "Annuler",
        "brdcstConf_right": "droite",
        "brdcstPart_broadcast_list": "Liste des diffuseurs",
        "calender_scheduled_calendar": "Calendrier",
        "calender_select_all": "S\u00e9lectionner tout",
        "calender_calender": "Calendrier",
        "calender_daily": "Journ\u00e9e",
        "calender_weekly": "Hebdomadaire",
        "calender_month": "Mois",
        "calender_today": "Aujourd'hui",
        "contact_alert_already_in_call": "Vous ne pouvez pas appeler un autre utilisateur, lorsque vous \u00eates d\u00e9j\u00e0 en ligne",
        "contact_alert_user_offline": "Utilisateur hors ligne",
        "meetReminder_scheduled_confirm": "Confirmation de la planification",
        "meetReminder_meeting_has_been_scheduled": "La r\u00e9union suivante est pr\u00e9vue \u00e0 ce moment",
        "meetReminder_start_meeting": "Commencer cette r\u00e9union",
        "meetReminder_join_meeting": "Rejoignez cette r\u00e9union",
        "meetReminder_quick_start_another_meeting": "D\u00e9marrage instantan\u00e9 d'une autre r\u00e9union",
        "myMeetItem_start": "D\u00e9marrer",
        "myMeetItem_for": "pour",
        "myMeetItem_minutes": "Minutes",
        "myMeetItem_host": "Organisateur :",
        "myMeet_my_meetings": "Mes r\u00e9unions",
        "myMeet_search_my_meetings": "Rechercher mes r\u00e9unions",
        "noScheMeet_no_meeting_scheduled\t": "o R\u00e9unions planifi\u00e9es",
        "noScheMeet_no_upcoming_meetings\t": "Aucune r\u00e9union n'est encore pr\u00e9vue. Vous pouvez cr\u00e9er une nouvelle planification ou commencer votre conf\u00e9rence rapidement d\u00e8s maintenant.",
        "noScheMeet_create_schedule": "Planifier une r\u00e9union",
        "noScheMeet_quick_start": "D\u00e9marrage instantan\u00e9",
        "noScheMeet_or": "OU",
        "roomSet_alert_select_license": "Veuillez s\u00e9lectionner la licence",
        "roomSet_manage_licenses": "G\u00e9rer les licences",
        "roomSet_package": "Offre",
        "roomSet_no_of_rooms": "Nombre de salles",
        "roomSet_no_of_user": "Nombre d'utilisateurs",
        "roomSet_purchased_on": "Achet\u00e9 le",
        "roomSet_expired_on": "Expir\u00e9 le",
        "roomSet_create_room": "Cr\u00e9er une salle",
        "dashboard_alert_cannot_start": "Vous ne pouvez pas commencer la r\u00e9union, lorsque vous \u00eates toujours pr\u00e9sent dans une autre salle",
        "dashboard_alert_cannot_join": "Vous ne pouvez pas participer \u00e0 la r\u00e9union, lorsque vous \u00eates d\u00e9j\u00e0 pr\u00e9sent dans une autre salle de conf\u00e9rence",
        "dashboard_quick_start_conf": "R\u00c9UNION INSTANTAN\u00c9E",
        "dashboard_loading": "Chargement...",
        "dashboard_maintenance_msg": "Veuillez noter que le 22 avril 2020, le serveur sera indisponible de 20h30 \u00e0 21h00 en raison d'une op\u00e9ration de maintenance.",
        "addCam_add_device": "Ajouter un dispositif vid\u00e9o",
        "addSipDev_add_sip_details": "Ajouter les d\u00e9tails SIP",
        "addSipDev_sip_address": "Adresse SIP :",
        "addSipDev_connect": "Se connecter",
        "addSipDev_enter_sip_address": "Entrez l'adresse SIP",
        "confNotf_notification": "Notifications",
        "confNotf_user_name": "Nom d'utilisateur",
        "confNotf_want_to_join": "souhaite rejoindre cette salle de r\u00e9union.",
        "confNotf_allow": "Autoriser",
        "confNotf_deny": "Refuser",
        "confNotf_ask_question": "Posez une question.",
        "confNotf_send_msg_lobby": "a envoy\u00e9 un message depuis le hall d'entr\u00e9e.",
        "lobby_participants_loddy": "Participants dans la salle d'attente",
        "lobby_pramote_all": "Autoriser tous",
        "lobby_user_name": "Nom d'utilisateur",
        "removeUserDlg_manage_user_selecting": "G\u00e9rez cet utilisateur en s\u00e9lectionnant l'une de ces options :",
        "removeUserDlg_user_name": "Nom d'utilisateur",
        "removeUserDlg_block_participant": "Bloquer une participant",
        "removeUserDlg_send_to_lobby": "Envoyer au Lobby",
        "removeUserDlg_remote_participant": "Supprimer un participant",
        "removeUserDlg_close": "Fermer",
        "PartList_participants_in_lobby": "Participants dans la salle d'attente",
        "PartList_alert_something_went_wrong": "Quelque chose s'est mal pass\u00e9, veuillez r\u00e9essayer",
        "PartList_in_webinar": "Dans le webinaire",
        "PartList_promote_all": "Tout promouvoir",
        "waitingRoom_waiting_room": "Salle d'attente",
        "waitingRoom_plz_wait_host_allow": "Veuillez attendre que l'organisateur vous autorise \u00e0 participer \u00e0 la r\u00e9union.",
        "waitingRoom_chat": "Chat",
        "waitingRoom_mins": "mins",
        "waitingRoom_no_msg_yet": "Pas encore de messages !",
        "waitingRoom_no_msg_from_host": "Aucun message de l'organisateur.",
        "waitingRoom_say_something": "Dites quelque chose !",
        "userRemoved_you_removed_by_host": "Vous avez \u00e9t\u00e9 retir\u00e9 de la liste des participants par l'organisateur",
        "invitSlide_invite": "Inviter",
        "invitSlide_add_email": "Ajouter des courriels",
        "invitSlide_add": "Ajouter",
        "invitSlide_broadcast_list": "Lien de diffusion",
        "invitSlide_invite_people_to_meeting": "Invitez des participants \u00e0 cette r\u00e9union, Saisissez et ajoutez des emails \u00e0 la liste pour envoyer l'invitation.",
        "invitSlide_err_invalid_id": "Identification email invalide",
        "particiChat_say_something": "Dites quelque chose !",
        "particiChat_no_chat_msg": "Pas encore de messages de chat !",
        "particiChat_start_conversation": "Commencez la conversation pour voir les messages ici.",
        "coBrows_host_share-video": "Attendez ! L'organisateur s'appr\u00eate \u00e0 partager une vid\u00e9o",
        "lobbyPartici_no_participants": "Aucun participant",
        "lobbyPartici_no_participants_lobby": "Il n'y a aucun participant dans la salle d'attente",
        "simulcast_alert_decline_access": "L'organisateur a refus\u00e9 l'acc\u00e8s",
        "simulcast_invalid_url": "URL invalide",
        "simulcast_no_host_available": "Il n'y a pas d'organisateur disponible pour le moment, veuillez prendre le r\u00f4le d'organisateur pour partager l'\u00e9cran",
        "conference_access_to_participants": "Acc\u00e8s aux participants",
        "conference_screen_share": "Partage d'\u00e9cran",
        "conference_chat": "Chat",
        "conference_lock_all": "Verrouiller tout",
        "conference_lock_conf": "Verrouillez l'acc\u00e8s \u00e0 la r\u00e9union",
        "conference_become_host": "Devenir organisateur",
        "conference_you_are_host": "Vous \u00eates l'organisateur",
        "conference_share": "Partager",
        "conference_document_share": "Partage de documents",
        "conference_content_share": "Partage de contenu",
        "conference_more": "Plus...",
        "conference_alert_no_host_aval_screen": "Il n'y a pas d'organisateur disponible pour le moment, veuillez devenir organisateur pour partager l'\u00e9cran",
        "conference_alert_no_host_aval_doc": "Aucun organisateur n'est disponible pour le moment, veuillez devenir organisateur pour partager le document",
        "conference_alert_err_sip_device": "Erreur lors de la connexion du dispositif SIP",
        "conference_alert_host_decline_access": "L'organisateur a refus\u00e9 l'acc\u00e8s",
        "conference_alert_invalid_url": "URL invalide",
        "conference_unmute_mic_start_talk": "Activez votre microphone pour commencer \u00e0 parler",
        "confTools_new_whiteboard": "Votre nouveau tableau blanc est ici",
        "confTools_video_sync": "Votre synchronisation vid\u00e9o",
        "confTools_microphone": "Microphone",
        "confTools_type_text_here": "Saisissez votre texte...",
        "confTools_whiteboard": "Tableau blanc",
        "confLibs_alert_broadcast_screen_failed": "L'\u00e9cran de diffusion a \u00e9chou\u00e9",
        "confLibs_broadcast_failed": "Echec de la diffusion",
        "chatContainer_say_something": "Dites quelque chose !",
        "chatContainer_no_chat_msg": "Pas encore de messages de chat !",
        "chatContainer_start_conversation": "Commencez la conversation pour voir les messages ici.",
        "fmyRoom_ree": "Gratuit",
        "meetRec_video_rec_meeting_name": "Enregistrements vid\u00e9o du nom de la r\u00e9union",
        "meetRec_page_view": "Vue de la page :",
        "recListView_title_name_rec": "Titre de l'enregistrement",
        "recListView_name_user": "Nom de l'utilisateur",
        "instavc_allow_Notes": "Permission",
        "brwUpg_req_fun_not_avail": "Les fonctionnalit\u00e9s demand\u00e9es ne sont pas support\u00e9es par votre navigateur",
        "brwUpg_meeting_req_fun_sup": "Ce service n'est pas support\u00e9 par votre navigateur.",
        "brwUpg_plz_upgrade": "Merci de changer de navigateur ou v\u00e9rifiez le param\u00e9trage de celui que vous utilisez. Le navigateurs support\u00e9s sont;",
        "header_content": "Gestion de contenus (Beta)",
        "header_loading": "Chargement ...",
        "crtePln_plz_enter_name": "Saisissez le nom de ce plan",
        "crtePln_plz_amount_Plan": "Saisissez le montant de ce plan",
        "crtePln_plz_enter_des": "Saisissez la description",
        "crtePln_Plz_sel_product": "Choisissez un produit",
        "crtePln_plz_sel_no_host": "Saisissez le nombre d'organisateurs",
        "crtePln_plz_enter_no_participants": "Saisissez le nombre de participants",
        "crtePln_plz_enter_roomno": "Saisissez le nombre de salles",
        "crtePln_select_period": "Choisissez un p\u00e9riode",
        "crtePln_sel_interval": "Choisissez un intervalle",
        "crtePln_update_succ": "Misa \u00e0 jour r\u00e9ussie",
        "crtePln_err_creating_plan": "Erreur en cr\u00e9ant ce plan",
        "brdcRaise_alert_question_50_char": "Votre question doit contenir un minimum de 50 caract\u00e8res",
        "cofCom_no_part_lobby": "Il n'y a personne dans la salle d'attente",
        "cofCom_no_participants": "Aucun participant",
        "cofCom_say_something": "Dites quelque chose",
        "confmUser_plz_provide_name_email": "Saisissez votre nom et votre email",
        "confmUser_notes": "Bloc notes",
        "confSetup_telepresence": "T\u00e9l\u00e9pr\u00e9sence",
        "confSetup_alert_not_generate_meetingID": "Impossible de g\u00e9n\u00e9rer l'identifiant de cette r\u00e9union, essayez plus tard.",
        "confSetup_auth_part_can_join": "Seuls les invit\u00e9s rejoignent cette r\u00e9union (Prot\u00e9g\u00e9 par Mot de passe)",
        "confSetup_invalid_link": "Lien invalide",
        "confSetup_meeting_notyet_started": "Cette r\u00e9union n'a pas encore d\u00e9marr\u00e9. Merci d'attendre ou de vous reconnecter plus tard. Si vous \u00eates l'organisateur, connectez vous \u00e0 votre licence InstaVC et d\u00e9marrez cette r\u00e9union.",
        "confSetup_meeting_locked_byhost": "Cette r\u00e9union est d\u00e9rouill\u00e9e par l'organisateur",
        "confSetup_meeting_notyet_started_wait_host": "Cette r\u00e9union n'a pas encore d\u00e9marr\u00e9. Merci d'attendre l'organisateur.",
        "newChat_panel_chat": "Panneau de Chat",
        "newChat_webinar_chat": "Chat du webinaire",
        "instaVc_server_busy": "Le serveur semble occup\u00e9! Tentative de connexion \u00e0 un autre serveur ...",
        "instaVc_server_busy_reload_tojoin": "Le serveur semble occup\u00e9! Relancer pour rejoindre la r\u00e9union",
        "instaVc_broadcast_scr_failed": "\u00c9chec de la diffusion de l'\u00e9cran",
        "instaVc_broadcast_failed": "\u00c9chec de diffusion",
        "instaVc_waiting_for_host": "En attente de la vid\u00e9o de l'organisateur",
        "modlCreate_plz_enter_title": "Veuillez saisir le titre",
        "modlCreate_questionnaire": "Questionnaire",
        "modlCreate_questionnaire_name": "Nom du questionnaire",
        "modlCreate_desc": "Description",
        "modlCreate_cancle": "Annuler",
        "modlCreate_poll": "Sondage",
        "mdlCretPoll_plz_enter_quest": "Saisissez une question",
        "mdlCretPoll_option_should_not_same": "Les options ne devraient pas \u00eatre les m\u00eames",
        "mdlCretPoll_plz_enter_option": "Saisissez le options",
        "mdlCretPoll_plz_select_type_option": "Choisissez le type d'options",
        "mdlCretPoll_alert_server_error": "Erreur de serveur interne, veuillez r\u00e9essayer",
        "mdlCretPoll_update_ques": "Modifier la question",
        "mdlCretPoll_create_ques": "Saisissez un question",
        "mdlCretPoll_Question": "Question",
        "mdlCretPoll_enter_que_here": "Saisissez votre question ici",
        "mdlCretPoll_single_sel_multi_choice": "Question \u00e0 choix unique",
        "mdlCretPoll_enter_ans_choice": "Saisissez les choix des r\u00e9ponses et cochez quand la r\u00e9ponse est correcte",
        "mdlCretPoll_end": "fin",
        "mdlCretPoll_cancle": "Annuler",
        "viewQues_viewQuest_delete_successfully": "Supprim\u00e9 avec succ\u00e8s",
        "viewQues_viewQuest_server_error": "Erreur de serveur interne, veuillez r\u00e9essayer",
        "viewQues_viewQuest_plz_try_again": "veuillez r\u00e9essayer",
        "mngContent_mngContent_content": "Contenu",
        "mngContent_mngContent_participants": "Participants",
        "mngContent_mngContent_grade": "Notes",
        "mngContent_mngContent_assign_quest": "Attribuer un questionnaire",
        "mngContent_mngContent_fav_prog_lang": "Quel langage par d\u00e9faut souhaitez vous utiliser?",
        "mngContent_mngContent_grade_settings": "Param\u00e9trage des notes",
        "mngContent_mngContent_pollings": "Sondages",
        "questStepper_you_cant_skip": "Vous ne pouvez pas sauter une \u00e9tape qui n'est pas facultative.",
        "questStepper_back": "Retour",
        "questStepper_skip": "Avancer",
        "questStepper_next": "Suivant",
        "showQue_obtained_marks": "Marques obtenues :",
        "viewUser_your_grade": "Votre note :",
        "package_one_host": "1 organisateur et",
        "package_participants": "participants",
        "package_recordings": "Enregistrement",
        "package_concurrentUser_room2": "20 utilisateurs simultan\u00e9s - 2 salles",
        "package_concurrentUser_room5": "30 utilisateurs simultan\u00e9s - 5 salles",
        "package_concurrentUser_room20": "100 utilisateurs simultan\u00e9s - 20 salles",
        "package_concurrentUser_room30": "200 utilisateurs simultan\u00e9s - 30 chambres",
        "package_concurrentUser_room50": "500 Utilisateurs simultan\u00e9s - 50 salles",
        "pastMeeting_chat_history_deleted": "L'historique des chats a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s",
        "pastMeeting_plz_try_again": "veuillez r\u00e9essayer",
        "pastMeeting_past_meeting_dtls": "D\u00e9tails des r\u00e9unions termin\u00e9es",
        "pastMeeting_past_meeting": "R\u00e9unions termin\u00e9es",
        "pastMeeting_room_name": "Nom de la salle :",
        "pastMeeting_duration": "Dur\u00e9e :",
        "pastMeeting_download_parti_atten": "T\u00e9l\u00e9charger Participants et invit\u00e9s",
        "pastMeeting_download_webinar": "T\u00e9l\u00e9charger le webinaire",
        "pastMeeting_participants": "Participants",
        "pastMeeting_attendees": "Participants",
        "pastMeeting_chat_history": "Historique du chat",
        "pastMeeting_notes": "Bloc notes",
        "pastMeeting_recordings": "Enregistrements",
        "pastMeeting_webinar_user": "Utilisateurs du webinaire",
        "pastMeeting_webinar_chat": "Chat du webinaire",
        "pastMeeting_no_participants_in_meeting": "Aucun participant \u00e0 cette r\u00e9union !",
        "pastMeeting_no_parti_attended_meeting": "Aucun participant n'a assist\u00e9 \u00e0 cette r\u00e9union.",
        "pastMeeting_guest_list": "Liste des invit\u00e9s",
        "pastMeeting_no_guest_in_meeting": "Aucun invit\u00e9 dans cette r\u00e9union",
        "pastMeeting_no_guests_were_invited ": "Aucun invit\u00e9 n'a assist\u00e9 \u00e0 cette r\u00e9union",
        "pastMeeting_meeting_chat_history": "Historique du chat de la r\u00e9union",
        "pastMeeting_delete_all": "Supprimer tout",
        "pastMeeting_no_chat_msg_inmeeting": "Aucun message de Chat dans cette r\u00e9union !",
        "pastMeeting_no_conver_during_meeting": "Il n'y a eu aucune conversation en chat pendant la r\u00e9union.",
        "pastMeeting_no_user_inwebinar": "Aucun utilisateur dans ce webinaire !",
        "pastMeeting_no_user_attand_webinar": "Aucun utilisateur n'a particip\u00e9 \u00e0 ce webinaire.",
        "pastMeeting_webinar_chat_history": "Historique du chat du webinaire",
        "pastMeeting_no_chat_msg_inwebinar": "Aucun message de Chat dans ce webinaire !",
        "pastMeeting_no_conver_during_webinar": "Il n'y a eu aucune conversation en chat pendant le webinaire.",
        "pastMeeting_del_chat_history": "Effacer l'historique des chats",
        "pastMeeting_delete_all_chat_history": "Vous \u00eates s\u00fbr de vouloir supprimer d\u00e9finitivement l'historique des chats ?",
        "pastMeeting_cancle": "Annuler",
        "pastMeeting_delete": "Supprimer",
        "schedul_webinar_event": "Webinaire",
        "schedul_webinar_description": "Description du webinaire",
        "schedul_upload_custom_banner": "T\u00e9l\u00e9chargez une banni\u00e8re personnalis\u00e9e pour votre webinaire.",
        "schedul_setting": "Param\u00e9trage",
        "schedulView_time": "Heure",
        "schedulView_edit": "Editer",
        "schedulView_enable_training_mode": "Activer le mode formation",
        "schedulView_audio_conference": "R\u00e9union Audio",
        "schedulView_enable_mix_video": "Activer le mode mixage par d\u00e9faut",
        "questions": "Questions",
        "Save": "Enregistrer",
        "answer_list": "Liste des r\u00e9ponses",
        "answer": "R\u00e9ponses",
        "answered": "R\u00e9ponse :",
        "correct_answer": "R\u00e9ponse correcte",
        "participants": "participants",
        "please_try_again": "veuillez r\u00e9essayer",
        "search": "Rechercher ...",
        "question": "Question",
        "questionnaire": "Questionnaire",
        "content": "Contenu",
        "address_book": "Carnet d'adresses",
        "view": "Voir",
        "rn": "RN",
        "quslsit_assig_que_list": "Liste des questionnaires assign\u00e9s",
        "quslsit_question_lists": "Listes de questionnaires",
        "quslsit_search": "Rechercher ...",
        "quslsit_assign_new_ques": "Attribuer un nouveau questionnaire pour cliquer sur le bouton Attribuer un questionnaire ci-dessus",
        "select_questionnaire": "S\u00e9lectionner le questionnaire",
        "duration": "Dur\u00e9e",
        "time_limit": "Limite de temps",
        "show_results": "Afficher les r\u00e9sultats",
        "content_group": "Groupe de contenus",
        "list_assigned_ques": "Liste des questions assign\u00e9es :",
        "mins": "mins",
        "marks": "Points",
        "questionnaire_list": "Liste des questionnaires",
        "edit_content": "Modifier le contenu",
        "queStepper_cant_skip": "Vous ne pouvez pas sauter une \u00e9tape qui n'est pas facultative.",
        "queStepper_skip": "Avancer",
        "alert_server_error": "Erreur de serveur interne, veuillez r\u00e9essayer",
        "delete_successfully": "Supprim\u00e9 avec succ\u00e8s",
        "pastMeeting_rn": "RN",
        "plz_enter_marks": "Veuillez indiquer le nombre de points attribu\u00e9 \u00e0 cette question",
        "plz_sel_crtans": "Veuillez s\u00e9lectionner la r\u00e9ponse correspondante",
        "truefalse_choice": "Vrai \/ Faux choix",
        "questionnarie": "Questionnarie",
        "content_title": "Contenu Titre",
        "media_title": "Titre du m\u00e9dia",
        "add_url_add": "Ajouter une adresse URL...",
        "val_shuld_grtr_from_val": "\u00e0 la valeur doit \u00eatre sup\u00e9rieure \u00e0 celle de la valeur",
        "val_shuld_grtr_grade": "de la valeur doit \u00eatre sup\u00e9rieure \u00e0 la note",
        "to_val": "pour valoriser",
        "enable_hand_raise": "Permettre de lever la main\/ poser une question dans un webinaire",
        "enable_waiting_room": "Activer la salle d'attente",
        "allow_only_invite": "Autoriser uniquement les personnes invit\u00e9es \u00e0 participer \u00e0 la r\u00e9union (prot\u00e9g\u00e9 par un mot de passe)",
        "guest_login_anonymous": "L'invit\u00e9 peut se connecter anonymement",
        "give_name_webinar": "Donnez un nom \u00e0 votre webinaire",
        "Webinar": "Webinaire",
        "polls_list": "Liste des sondages",
        "no_poll_assign": "Aucun sondage n'a encore \u00e9t\u00e9 attribu\u00e9.",
        "poll_view": "Sondage",
        "filter_block": "bloc filtre",
        "file_size": "Taille du fichier",
        "select_room": "Veuillez choisir une chambre",
        "provide_event_name": "Veuillez indiquer le nom de l'\u00e9v\u00e9nement",
        "end_time_greater_start_time": "L'heure de fin doit \u00eatre sup\u00e9rieure \u00e0 l'heure de d\u00e9but !",
        "invite_people_meeting": "Inviter des participants \u00e0 cette r\u00e9union",
        "download_ical": "T\u00e9l\u00e9charger iCal",
        "download": "T\u00e9l\u00e9charger",
        "delete_meeting": "Supprimer cette r\u00e9union",
        "new_event": "Nouvel \u00e9v\u00e9nement",
        "end_repeat": "fin de la r\u00e9p\u00e9tition",
        "invite_users_timezone": "inviter les utilisateurs avec le fuseau horaire suivant",
        "update_event": "Mise \u00e0 jour de l'\u00e9v\u00e9nement",
        "create_event": "Cr\u00e9er un \u00e9v\u00e9nement",
        "wrong_password": "Mot de passe incorrect",
        "college": "Coll\u00e8ge",
        "university": "Universit\u00e9",
        "country": "Pays",
        "time_period": "P\u00e9riode de temps :",
        "currently_working_here": "Travaillant actuellement ici",
        "from": "De :",
        "graduated": "Dipl\u00f4m\u00e9",
        "enter_description": "Entrez votre description ici...",
        "concentration": "Concentration",
        "school": "\u00c9cole",
        "poll_question": "Question du sondage",
        "create_poll_ques": "Cr\u00e9er une question de sondage",
        "options": "options",
        "no_ques_assigned_yet": "Aucune question n'a encore \u00e9t\u00e9 assign\u00e9e !",
        "create_new_ques_click_create_ques": "Cr\u00e9er une nouvelle question, pour cliquer sur le bouton Cr\u00e9er une question ci-dessus",
        "enter_room_name": "Veuillez entrer le nom de la salle",
        "billed_annually": "* Facturation annuelle",
        "subscribe_now": "Abonnez-vous maintenant",
        "group": "Groupe",
        "sample_webinar": "Exemple de webinaire",
        "webinar_affiliate": "Webinaire sur les affili\u00e9s",
        "webinar_one": "Webinaire 1",
        "workspace": "Espace de travail",
        "company": "Soci\u00e9t\u00e9",
        "add_another": "Ajouter un autre",
        "assignment": "Taches",
        "assignments": "Taches",
        "create_new_poll": "Cr\u00e9er une nouvelle question de sondage pour l'attribuer",
        "plz_title_url": "Plaese Entrez le titre et l'URL",
        "votes": "Votes",
        "enter_content_title": "Veuillez saisir le titre du contenu",
        "failed_result": "r\u00e9sultat manqu\u00e9",
        "removed_successfully": "Supprim\u00e9e avec succ\u00e8s",
        "enter_duration": "Veuillez indiquer la dur\u00e9e",
        "select_questionnarie": "Veuillez s\u00e9lectionner la questionnarie",
        "no_assignments": "Pas d'affectations",
        "create_new_assignment": "Cr\u00e9er une nouvelle tache, pour cr\u00e9er cliquez sur le bouton Cr\u00e9er une tache ci-dessus",
        "create_assignment": "Cr\u00e9er une tache",
        "assignments_list": "Liste des taches",
        "assignment_description": "Description de la tache",
        "assignment_name": "Nom de la tache",
        "update_assignment": "Mise \u00e0 jour de l'affectation",
        "add_new_assignment": "Ajouter une nouvelle tache",
        "assignment_list": "Liste des taches",
        "assign_assignments": "Affectation des t\u00e2ches",
        "assigned_assignments_list": "Liste des taches assign\u00e9es",
        "assignment_answer": "R\u00e9ponse \u00e0 la tache",
        "no_assig_submitted": "Aucun devoir n'a encore \u00e9t\u00e9 soumis.",
        "no_assig_submitted_participants": "Aucun devoir n'a encore \u00e9t\u00e9 soumis par les participants.",
        "view_assignment": "Voir la tache",
        "assigned_participants": "Participants assign\u00e9s",
        "select_assignment": "S\u00e9lectionner l'affectation",
        "fill_your_assignment": "Remplissez votre mission",
        "submit_assignment": "Soumettre une tache",
        "assignment_details": "D\u00e9tails de la tache",
        "assignment_submit_success": "Tache soumise avec succ\u00e8s",
        "assignment_saved_success" : "Devoir enregistré avec succès",
        "how_to_get_started": "Comment d\u00e9marrer.",
        "create_new_room": "Cr\u00e9er une nouvelle salle",
        "create_room_add_participants": "Cr\u00e9ez une nouvelle salle et ajoutez des participants \u00e0 la salle.",
        "repeats_every": "R\u00e9p\u00e9te chaque",
        "now": "Maintenant",
        "Plz_enter_title_meeting": "Veuillez entrer le titre de la r\u00e9union",
        "no_start_time": "Aucune heure de d\u00e9but trouv\u00e9e",
        "no_end_time": "Pas de fin de temps trouv\u00e9e",
        "item_id_not_found": "ID de l'article Non trouv\u00e9",
        "msg_title_not_found": "Titre du message Non trouv\u00e9",
        "plz_join_conf_clicking_link": "Veuillez rejoindre la r\u00e9union en cliquant sur le lien suivant",
        "hi_there": "Salut,",
        "room_permanently": "Chambre en permanence ?",
        "sure_want_to_delete_participants": "Vous \u00eates s\u00fbr de vouloir supprimer ce participant ?",
        "delete_participant": "Supprimer un participant",
        "add_email": "Ajouter une email",
        "add_participants_to_the_room": "Ajoutez des participants \u00e0 cette salle en saisissant leur adresse email dans la zone de saisie ci-dessous.",
        "no_of_users": "Nombre d'utilisateurs",
        "edit_the_name": "Vous pouvez modifier le nom et le num\u00e9ro d'utilisateur de cette salle.",
        "delete_room": "Supprimer une salle",
        "are_you_sure_delete": "Vous \u00eates s\u00fbr, vous voulez supprimer",
        "delete_this_room": "Supprimer cette salle",
        "delete_room_will_parmanently": "En cliquant sur Supprimer, cette pi\u00e8ce sera supprim\u00e9e d\u00e9finitivement",
        "enable_storage": "Activer le stockage",
        "enable_recordings": "Activer les enregistrements",
        "enable_SIP": "Activer le SIP",
        "addons": "Modules compl\u00e9mentaires",
        "expires_on": "Expire le",
        "purchased_on": "Achet\u00e9 le",
        "more_storage": "Plus de stockage",
        "total_storage": "Stockage total",
        "storage_occupied": "Stockage occup\u00e9",
        "added": "Ajout\u00e9",
        "open_graphs": "Graphiques ouverts",
        "participant_controls": "Contr\u00f4les des participants",
        "dashboard_controls ": "Contr\u00f4les du tableau de bord",
        "start_meeting": "Commencer une r\u00e9union",
        "join_a_meeting": "Participer \u00e0 une r\u00e9union",
        "meeting_settings": "Param\u00e8tres de la r\u00e9union",
        "videos_to_get_started": "Vid\u00e9os pour commencer",
        "if_you_are_host": "Si vous \u00eates un h\u00f4te, cliquez sur le bouton ci-dessous pour commencer la r\u00e9union",
        "guest_link": "Lien invit\u00e9",
        "pay_now": "PAYEZ MAINTENANT",
        "promo_code_apply_here": "Vous avez un code de promotion ? Postulez ici",
        "per_month": "par mois",
        "billed_for": "factur\u00e9 pour",
        "gst_applicable": "Conform\u00e9ment aux normes gouvernementales, une TPS suppl\u00e9mentaire de 18 % sera applicable aux clients en Inde.",
        "select_country_code": "S\u00e9lectionnez le code du pays",
        "country_code": "Code pays",
        "enter_email_id": "Entrez l'adresse e-mail ...",
        "downLoad_chat": "Chat en bas de page",
        "allow_guest_control_their": "Permettre aux invit\u00e9s de contr\u00f4ler leur vid\u00e9o\/audio",
        "below_list_people_invited": "Voici la liste des personnes invit\u00e9es",
        "verification_code": "Code de v\u00e9rification",
        "open_link_enter_verify_code": "Ouvrez le lien URL ci-dessous, et entrez votre code de v\u00e9rification pour l'int\u00e9gration",
        "social_media_integration": "Int\u00e9gration des m\u00e9dias sociaux",
        "integrate_social_media_platform": "Vous pouvez int\u00e9grer des plateformes de m\u00e9dias sociaux, en cliquant sur un bouton, vous obtiendrez un code de v\u00e9rification, utilisez-le pour l'int\u00e9gration.",
        "plz_enter_val_email": "Veuillez entrer une adresse \u00e9lectronique valide",
        "record": "Dossier",
        "in_conference": "En r\u00e9union",
        "password_if_any": "Mot de passe (le cas \u00e9ch\u00e9ant)",
        "stop_send": "Stop &amp ; Envoyer",
        "broadcast_not_enabled_meeting": "Diffusion non activ\u00e9e pour cette r\u00e9union",
        "facebook_url": "URL de Facebook",
        "enter_facebook_url": "Entrez l'URL de Facebook RTMB",
        "add_facebook_url": "Ajouter l'URL RTMP de Facebook",
        "youtube_url": "URL Youtube",
        "enter_youtube_url": "Entrez l'URL de Youtube RTMB",
        "add_youtube_url": "Ajouter l'URL RTMP de Youtube",
        "register": "S'inscrire",
        "time_of_program": "Dur\u00e9e du programme",
        "date_of_program": "Date du programme",
        "name_program_interested": "Nom du programme int\u00e9ress\u00e9",
        "email_id": "Adresse \u00e9lectronique",
        "dob": "Date de naissance",
        "applicant_address": "Adresse du demandeur",
        "qualification": "Qualification",
        "designation": "D\u00e9signation",
        "org_name_address": "Nom et adresse de l'organisation",
        "fullname_participant": "Nom complet du participant",
        "registration_form": "Formulaire d'inscription",
        "thanks_submitting_data": "Merci de nous avoir transmis vos donn\u00e9es",
        "manage_content": "G\u00e9rer le contenu",
        "API_settings": "Param\u00e8tres de l'API",
        "schedule_API": "Programme API",
        "image_upload_success": "image t\u00e9l\u00e9charg\u00e9e avec succ\u00e8s",
        "less_than_10MB": "veuillez t\u00e9l\u00e9charger un fichier de moins de 10MB",
        "at_time_of_event": "Au moment de l'\u00e9v\u00e9nement",
        "min_5": "5 minutes avant",
        "min_10": "10 minutes avant",
        "min_15": "15 minutes avant",
        "min_30": "30 minutes avant",
        "hrs_1": "1 heure avant",
        "hrs_2": "2 heures avant",
        "day_1": "1 jour avant",
        "day_2": "2 jours avant",
        "jan": "Jan",
        "feb": "F\u00e9vrier",
        "mar": "Mar",
        "apr": "Apr",
        "may": "Mai",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ao\u00fbt",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "D\u00e9c.",
        "mon": "Mon",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Fri",
        "sat": "Sam",
        "sun": "Dim",
        "all_day": "toute la journ\u00e9e",
        "starts_ddmmyyyy": "commence (jj\/mm\/aaaa)",
        "ends_ddmmyyyy": "fin (jj\/mm\/aaaa)",
        "ddmmyyyy": "(jj\/mm\/aaaa)",
        "by_dayweek": "Par jour\/semaine",
        "never": "Jamais",
        "on_date": "Date",
        "alert": "Alerte",
        "multi_factor_auth": "Activer l'authentification multi-facteurs (AMF)",
        "advanced_settings": "Param\u00e8tres avanc\u00e9s",
        "verify_Otp": "V\u00e9rifier l'Otp",
        "otp_sent_mobile": "Saisissez l'OTP envoy\u00e9 \u00e0 votre num\u00e9ro de t\u00e9l\u00e9phone portable",
        "update_mobile": "Mise \u00e0 jour mobile",
        "mob_verfi_pending": "La v\u00e9rification de votre t\u00e9l\u00e9phone portable est en cours.",
        "mobile_number": "Num\u00e9ro de t\u00e9l\u00e9phone portable",
        "enter_Otp": "Entrez Otp",
        "enter_mob_no": "veuillez saisir le num\u00e9ro de t\u00e9l\u00e9phone portable",
        "sure_want_to_delete_rec": "\u00cates-vous s\u00fbr de vouloir supprimer l'enregistrement T0",
        "delete_recording": "Supprimer l'enregistrement",
        "invalid_credentials": "Titres de comp\u00e9tences non valables",
        "join_conf_by_clicking_link": "Veuillez vous joindre \u00e0 la r\u00e9union en cliquant sur le lien suivant",
        "valid_room_name": "Veuillez entrer un nom de salle valide",
        "internal_server_error": "Erreur de serveur interne, veuillez r\u00e9essayer",
        "room_limit_exceed": "Limite de chambre d\u00e9pass\u00e9e",
        "cant_start_meeting_already_goingon": "Vous ne pouvez pas commencer une r\u00e9union, car une r\u00e9union est d\u00e9j\u00e0 en cours.",
        "video_recordings": "Enregistrements vid\u00e9o",
        "hindi": "Hindi",
        "gujarati": "Gujarati",
        "kannada": "Kannada",
        "marathi": "Marathi",
        "tamil": "Tamil",
        "telugu": "Telugu",
        "urdu": "Urdu",
        "spanish": "Espagnol",
        "malyalam": "Malyalam",
        "italian": "Italien",
        "bangla": "Bangla",
        "portuguese": "Portugais",
        "create_new_content": "Cr\u00e9er du contenu",
        "create_new_group": "Cr\u00e9er un groupe",
        "noScheMeet_no_meeting_scheduled": "Aucune r\u00e9union pr\u00e9vue",
        "noScheMeet_no_upcoming_meetings": "Aucune r\u00e9union n'est encore pr\u00e9vue. Vous pouvez cr\u00e9er une nouvelle planification ou commencer votre conf\u00e9rence instantan\u00e9e d\u00e8s maintenant.",
        "whiteboard": "Tableau blanc",
        "video_syn": "Sync vid\u00e9o",
        "notepad": "Bloc-notes",
        "enable_handraise": "Permettre la lev\u00e9e des mains dans un webinaire",
        "F": "Param\u00e8tres de la r\u00e9union",
        "social_integration": "Int\u00e9gration sociale",
        "advanced": "Avanc\u00e9",
        "add_youtube": "Ajouter Youtube",
        "plugins": "Plugins",
        "subtitles": "Sous-titres",
        "view_local": "Voir la section locale",
        "hide_local": "Masquer Local",
        "switch_conf_mode": "Passer en mode conf\u00e9rence",
        "switch_pres_mode": "Passer en mode pr\u00e9sentateur",
        "conference_locked": "Conf\u00e9rence verrouill\u00e9e",
        "conference_unlocked": "Conf\u00e9rence d\u00e9bloqu\u00e9e",
        "sharing_tools": "Outils de partage",
        "recording": "Enregistrement",
        "plz_wait_host_shr_video": "Attendez, s'il vous pla\u00eet ! L'organisateur est sur le point de partager une vid\u00e9o",
        "supported_sources_include": "Les sources soutenues sont notamment",
        "team_plugins": "Plugins TEAMS",
        "open": "Voir",
        "click": "Cliquez",
        "more_app": "Plus d'applications",
        "upload_custom_app": "T\u00e9l\u00e9charger une application personnalis\u00e9e",
        "download_team_plugin": "T\u00e9l\u00e9charger le plugin de TEAMS",
        "install_mng_app_microsoft_team": "Comment installer et g\u00e9rer l'application dans les \u00e9quipes Microsoft",
        "microsoft_step1": "\u00c9tape 1 : Ouvrir Microsoft TEAMS",
        "microsoft_step1_para1": "Pour commencer, vous devez d'abord t\u00e9l\u00e9charger le plugin TEAMS sur votre syst\u00e8me, disponible en haut \u00e0 droite de cette page. Ensuite, ouvrez Microsoft TEAMS et choisissez",
        "microsoft_step1_para2": "les options de navigation pour visualiser les applications de TEAMS.",
        "microsoft_step2": "\u00c9tape 2 : Acc\u00e9der Plus d'applications",
        "microsoft_step2_para1": "Vous trouverez ici quelques applications, ainsi qu'un bouton intitul\u00e9 \"Autres applications\". Cliquez",
        "microsoft_step2_para2": "pour v\u00e9rifier l'option de t\u00e9l\u00e9chargement personnalis\u00e9 et les autres options de la boutique.",
        "microsoft_step3": "\u00c9tape 3 : Chargement de l'application",
        "microsoft_step3_para1": "Une fois la boutique ouverte, vous pouvez trouver un",
        "microsoft_step3_para2": "dans la navigation de gauche. Cliquez dessus et t\u00e9l\u00e9chargez votre application plugin ici.",
        "microsoft_step4": "\u00c9tape 4 : S\u00e9lectionner l'application InstaVC dans la boutique",
        "microsoft_step4_para1": "Lorsque la fen\u00eatre s'ouvre, s\u00e9lectionnez le plugin InstaVC depuis votre syst\u00e8me et qui a \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9 (\u00e9tape 1) et cliquez",
        "microsoft_step5": "\u00c9tape 5 :Chargement de l'application Microsoft TEAMS",
        "microsoft_step5_para1": "Apr\u00e8s avoir t\u00e9l\u00e9charg\u00e9 le fichier, il est charg\u00e9 dans la liste des applications de Microsoft TEAMS. Vous pouvez alors cliquer sur l'application pour la visualiser et l'ajouter aux \u00e9quipes.",
        "microsoft_step6": "\u00c9tape 6 : Ouvrez l'application InstaVC",
        "microsoft_step6_para1": "Une fois que vous avez cliqu\u00e9 sur l'application InstaVC, vous pouvez maintenant voir les d\u00e9tails complets de l'application ainsi qu'un bouton pour",
        "microsoft_step6_para2": "pour ajouter cette application Microsoft TEAMS",
        "microsoft_step7": "\u00c9tape 7 : InstaVC ajout\u00e9 \u00e0 Microsoft TEAMS",
        "microsoft_step7_para1": "Votre application sera d\u00e9sormais ajout\u00e9e \u00e0 Microsoft TEAMS dans le menu de navigation \u00e0 gauche pour une utilisation facile et personnalisable.",
        "ddyymm": "JJ\/MM\/AAAA",
        "fill_details_for_webinar": "Veuillez remplir vos donn\u00e9es d'inscription pour le webinaire \u00e0",
        "microsoft_teams": "Microsoft TEAMS",
        "microsoft_outlook": "Microsoft Outlook",
        "select_the_plan": "Veuillez s\u00e9lectionner le plan",
        "enter_company_code": "Veuillez saisir le code de la soci\u00e9t\u00e9",
        "enter_code": "Veuillez entrer le code",
        "enter_valid_coupon_code": "Veuillez saisir un num\u00e9ro de coupon valide",
        "coupon_alreadt_taken": "Ce num\u00e9ro de coupon a d\u00e9j\u00e0 \u00e9t\u00e9 utilis\u00e9",
        "error_updating_plan": "Erreur dans la mise \u00e0 jour de votre plan",
        "unit": "unit\u00e9",
        "referrals": "R\u00e9f\u00e9rents",
        "sel_coupon": "Veuillez s\u00e9lectionner le coupon",
        "share_val_0_99": "La valeur partag\u00e9e doit \u00eatre comprise entre 0 et 99",
        "enter_share_val": "Veuillez entrer la valeur de l'action",
        "valid_commission_per": "Veuillez entrer le pourcentage de commission valide",
        "enter_commission_per": "Veuillez indiquer le pourcentage de la Commission",
        "enter_commission_name": "Veuillez entrer le nom de la Commission",
        "sync_successfully": "Les utilisateurs se synchronisent avec succ\u00e8s",
        "room_deleted_suc": "Salle supprim\u00e9e avec succ\u00e8s",
        "lic_deleted_suc": "Licence supprim\u00e9e",
        "female": "Femme",
        "male": "Homme",
        "insta_conference": "Insta Conference",
        "quick_meeting_by": "R\u00e9union instantan\u00e9e par",
        "in_lobby": "Dans la salle d'attente",
        "switch_to_broadcast": "Passer \u00e0 la diffusion",
        "Broadcasters_5": "Diffuseurs (5)",
        "Participants_5": "Participants (5)",
        "search_participants": "Rechercher des participants",
        "host_controls": "Contr\u00f4les de l'organisateur",
        "deleteroom": "Supprimer une salle",
        "pm": "PM",
        "am": "AM",
        "email_exist_inroom": "Le courrier \u00e9lectronique existe d\u00e9j\u00e0 dans cette salle",
        "type_a_message": "Tapez un message...",
        "please_enter_user_limit": "Veuillez entrer le nombre max d'utilisateurs",
        "user_limit_exceeded": "D\u00e9passement de la limite du nombre d'utilisateur possible",
        "sel_country_code": "Veuillez s\u00e9lectionner le code du pays",
        "available_storage": "Stockage disponible",
        "enter_phone_number": "Entrez le num\u00e9ro de t\u00e9l\u00e9phone",
        "startdate_less_enddate": "veuillez s\u00e9lectionner une date de d\u00e9but inf\u00e9rieure \u00e0 la date de fin",
        "havent_add_data": "Vous n'avez pas encore ajout\u00e9 de donn\u00e9es, veuillez ajouter des donn\u00e9es.",
        "professional_skills": "Comp\u00e9tences professionnelles",
        "enter_prof_skills": "Saisir les comp\u00e9tences professionnelles",
        "Present_Invitations": "Invitations actuelles",
        "sending": "Envoi en cours ...",
        "sent": "Envoy\u00e9 \u00e0",
        "invite_10ppl_only": "Vous ne pouvez inviter que 10 personnes au maximum",
        "join_meeting": "Rejoindre la r\u00e9union",
        "enter_doc_title": "Entrez le titre du document",
        "meeting_name": "Nom de la r\u00e9union",
        "select_the_weeks": "Veuillez s\u00e9lectionner les semaines",
        "grade": "Note",
        "coference_ID": "ID de conf\u00e9rence...",
        "dont_find_room_meetingid": "Nous ne trouvons aucune salle, qui soit associ\u00e9e \u00e0 cet identifiant de r\u00e9union",
        "wireless_share": "Partage sans fil",
        "video_layout": "Mise en page de la vid\u00e9o",
        "speaker_screen": "\u00c9cran du haut-parleur",
        "presentation_screen": "\u00c9cran de pr\u00e9sentation",
        "multiple_display": "Affichage multiple",
        "hellow": "Bonjour",
        "enter_passcode": "Entrez le code d'acc\u00e8s",
        "another_meeting_stillon": "Une autre r\u00e9union est toujours en cours, vous ne pouvez pas commencer cette r\u00e9union maintenant",
        "SIP_device": "Dispositif SIP",
        "instavc_whiteBoard": "Tableau blanc InstaVC",
        "speaker": "Orateur",
        "instavc_notepad": "Bloc-notes InstaVC",
        "promote_in": "Promouvoir dans",
        "guest": "Invit\u00e9",
        "breakout_rooms": "Salles en petits groupes",
        "stop_broadcast": "Arr\u00eat de la diffusion",
        "noise_suppress": "Suppression du bruit",
        "echo_cancel": "Annulation de l'Echo :",
        "enter_name_here": "Entrez le nom ici",
        "Viewer": "Visionneuse",
        "SIP_user": "Utilisateur SIP",
        "remove_participants": "Supprimer des participants",
        "disable_audio_video": "D\u00e9sactiver l'audio et la vid\u00e9o",
        "disable_audio": "D\u00e9sactiver l'audio",
        "enable_audio": "Activer l'audio",
        "disable_video": "D\u00e9sactiver la vid\u00e9o",
        "enable_video": "Activer la vid\u00e9o",
        "audio_video": "Audio et vid\u00e9o",
        "audio_only": "Audio uniquement",
        "video_only": "Vid\u00e9o uniquement",
        "outlook_addins": "Compl\u00e9ments Outlook",
        "install_microsoft": "Comment installer et g\u00e9rer les modules d'extension dans Microsoft Outlook",
        "outlook_step1": "\u00c9tape 1 : Copier le lien et ouvrir Outlook",
        "first_copy_link": "Copiez d'abord le lien",
        "add_plugin_oulook": "d'ici pour ajouter le plugin \u00e0 votre outlook.",
        "outlook_step2": "\u00c9tape 2 : Obtenir des compl\u00e9ments",
        "outlook_step2_para": "Ouvrez maintenant outlook et sous l'onglet Home vous trouverez une option \"Obtenir des compl\u00e9ments\". Cliquez dessus pour voir les compl\u00e9ments et autres options personnalis\u00e9es.",
        "outlook_step3": "\u00c9tape 3 : Mes compl\u00e9ments",
        "outlook_step3_para": "Vous pouvez maintenant consulter la page des compl\u00e9ments avec la navigation de gauche. Allez \u00e0 Mes modules compl\u00e9mentaires pour g\u00e9rer vos modules compl\u00e9mentaires.",
        "outlook_step4": "\u00c9tape 4 : Ajout de compl\u00e9ments personnalis\u00e9s",
        "outlook_step4_para": "Vous trouverez ici un menu d\u00e9roulant\" Ajouter un compl\u00e9ment personnalis\u00e9\" dans \"Mes Compl\u00e9ments\". S\u00e9lectionnez Ajouter \u00e0 partir de l'URL dans la liste d\u00e9roulante.",
        "outlook_step5": "\u00c9tape 5 : Ajout d'un compl\u00e9ment priv\u00e9 \u00e0 partir de l'URL",
        "outlook_step5_para": "Vous pouvez maintenant voir une fen\u00eatre vous demandant d'ajouter un compl\u00e9ment priv\u00e9 \u00e0 partir de l'URL. Collez maintenant le lien que vous avez copi\u00e9 (\u00e9tape 1) dans le champ de saisie et cliquez sur OK, cela installe le compl\u00e9ment dans outlook.",
        "outlook_step6": "\u00c9tape 6 : InstaVC ajout\u00e9 dans mes Compl\u00e9ments Outlook",
        "outlook_step6_para": "Apr\u00e8s l'ajout, vous pouvez v\u00e9rifier le compl\u00e9ment ajout\u00e9 dans votre liste \"Mes Compl\u00e9ments\". \u00c0 partir de l\u00e0, vous pouvez g\u00e9rer vos compl\u00e9ments plus en d\u00e9tail.",
        "outlook_step7": "\u00c9tape 7 : Fermer et rouvrir Outlook",
        "outlook_step7_para": "Apr\u00e8s l'installation, assurez-vous de fermer une fois Oultlook et de la rouvrir pour voir l'extension.",
        "outlook_step8": "\u00c9tape 8 : Aller aux nouveaux \u00e9l\u00e9ments",
        "outlook_step8_para": "Apr\u00e8s avoir ouvert outlook, vous pouvez maintenant aller \u00e0 \"Nouvelles R\u00e9unions\" pour voir l'ajout de l'InstaVC dans outlook.",
        "outlook_step9": "\u00c9tape 9 : Ouvrir une R\u00e9union l'InstaVC",
        "outlook_step9_para": "Une fois les r\u00e9unions ouvertes, une fen\u00eatre de composition de courrier \u00e9lectronique s'ouvrira avec le module compl\u00e9mentaire InstaVC Meeting activ\u00e9 dans la barre sup\u00e9rieure sous l'onglet des r\u00e9unions.",
        "outlook_step10": "\u00c9tape 10 : Cr\u00e9er une planification",
        "outlook_step10_para": "A partir de la page de composition du courrier, cliquez sur R\u00e9unions Instavc pour cr\u00e9er une nouvelle planification de r\u00e9union. Si c'est la premi\u00e8re fois que vous vous connectez \u00e0 une r\u00e9union Instavc, vous serez connect\u00e9 avec le Login de la r\u00e9union Instavc sur le c\u00f4t\u00e9 droit. Pour les utilisateurs d\u00e9j\u00e0 connect\u00e9s, ils seront dirig\u00e9s vers la liste des salles et pourront planifier une r\u00e9union",
        "outlook_step11": "\u00c9tape 11 : Ouvrir une r\u00e9union InstaVC",
        "outlook_step11_para": "Vous pouvez planifiez de r\u00e9union calendrier sur le c\u00f4t\u00e9 gauche et s\u00e9lectionner une salle sur le c\u00f4t\u00e9 droit pour programmer une r\u00e9union dans une salle particuli\u00e8re. Une fois que vous avez cr\u00e9\u00e9 un calendrier, vous pouvez voir le bouton \"Commencer la r\u00e9union\". De l\u00e0, vous pouvez cliquer et commencer la r\u00e9union.",
        "outlook_step12": "\u00c9tape 12 : Voir l'horaire dans le calendrier",
        "outlook_step12_para": "Une fois que vous avez planifi\u00e9 une r\u00e9union, la prochaine fois que vous ouvrirez le calendrier, vous pourrez \u00e9galement consulter vos horaires dans le calendrier.",
        "outlook_step13": "\u00c9tape 13 : R\u00e9union planifi\u00e9e",
        "outlook_step13_para": "Une fois que vous planifi\u00e9 une r\u00e9union, vous pouvez voir le courrier compos\u00e9 ainsi qu'un bouton \"Start Meeting\" sur le c\u00f4t\u00e9 droit.",
        "sel_declaration": "Veuillez s\u00e9lectionner la d\u00e9claration",
        "invalid_company_code": "Code de soci\u00e9t\u00e9 invalide",
        "affiliate_acc": "Votre compte d'affili\u00e9 est en attente d'approbation.",
        "aff_acc_approved": "Votre demande compte d'affiliation est approuv\u00e9.",
        "aff_acc_rej": "Votre demande compte d'affili\u00e9 est rejet\u00e9e.",
        "aff_TC": "Conditions g\u00e9n\u00e9rales des affili\u00e9s",
        "ref_par_agreement": "ACCORD AVEC LE PARTENAIRE DE R\u00c9F\u00c9RENCE",
        "aff_partner_agreement": "Le pr\u00e9sent accord de partenariat, constitu\u00e9 de la pr\u00e9sente page de couverture et des conditions commerciales ci-jointes (collectivement, le pr\u00e9sent \"accord\"), est \u00e9tabli et conclu par et entre PeopleLink Unified Communications Pvt Ltd (ci-apr\u00e8s d\u00e9nomm\u00e9 PeopleLink) et \"le partenaire\" ou \"vous\". \"Partenaire\" ou \"Vous\" d\u00e9signe la personne ou la soci\u00e9t\u00e9 (y compris le nom de la soci\u00e9t\u00e9 et d'autres informations) dont le nom figure dans le formulaire qui lui a \u00e9t\u00e9 soumis. L'accord devient contraignant une fois que vous avez rempli et soumis le formulaire du programme de parrainage (\"Formulaire\") pour indiquer votre acceptation de cet accord. PeopleLink et le Partenaire sont parfois appel\u00e9s \"Partie\", et ensemble les \"Parties\".",
        "background": "Contexte",
        "aff_market_advertise": "PeopleLink propose des services et des solutions de communication unifi\u00e9e et notamment: InstaVC. Le partenaire souhaite promouvoir, commercialiser et faire conna\u00eetre les produits et solutions de PeopleLink aux clients potentiels de PeopleLink (\"R\u00e9f\u00e9rences\") par le biais de son ou ses sites Web et d'autres canaux de commercialisation, conform\u00e9ment au pr\u00e9sent accord.",
        "agreement": "Accord",
        "aff_parties_agree": "Les parties conviennent de ce qui suit :",
        "heading1": "ENGAGEMENTS DU PROGRAMME",
        "heading2": "R\u00c9F\u00c9RENTS QUALIFI\u00c9ES ET COMMISSIONS.",
        "heading3": "DUR\u00c9E ET R\u00c9SILIATION.",
        "heading4": "GENERALITES",
        "the_program": "Le programme.",
        "to_participate_program_partner": "Pour participer au programme, le partenaire doit remplir la demande en ligne de participation au programme qui se trouve sur PeopleLink ou sur ses sites web associ\u00e9s (\"Site\") et conclure le pr\u00e9sent accord. PeopleLink peut accepter ou rejeter toute demande \u00e0 sa seule discr\u00e9tion.",
        "aff_str11": "Accords juridiques.",
        "aff_str12": "Activit\u00e9s de promotion et de r\u00e9f\u00e9rence :",
        "aff_str13": "Activit\u00e9s interdites.",
        "aff_str14": "Utilisation autoris\u00e9e des marques PeopleLink",
        "aff_str15": "Passif.",
        "aff_str16": "Relations avec les clients.",
        "aff_str11_para": "Dans le cadre de sa participation au Programme et en agissant en tant que Partenaire de PeopleLink, le Partenaire accepte et consent par les pr\u00e9sentes aux termes du pr\u00e9sent Accord et du Programme, aux Lignes directrices et \u00e0 toute autre demande et r\u00e8gle \u00e9tablie par PeopleLink de temps \u00e0 autre, \u00e0 sa discr\u00e9tion raisonnable, en relation avec la participation continue du Partenaire au Programme et \u00e0 la promotion des produits, solutions et services de PeopleLink aux R\u00e9f\u00e9rences. Dans toutes ses activit\u00e9s dans le cadre du pr\u00e9sent accord, et en particulier les activit\u00e9s li\u00e9es \u00e0 la promotion de PeopleLink par le partenaire, le partenaire doit coop\u00e9rer avec PeopleLink et agir de bonne foi. En concluant le pr\u00e9sent accord, le Partenaire reconna\u00eet et accepte les conditions et r\u00e8gles d\u00e9finies dans les conditions de service de PeopleLink",
        "aff_str12_para": "Le partenaire accepte de s'engager dans une promotion active et continue des produits et solutions PeopleLink dans divers canaux de commercialisation en utilisant les marques sous licence et le mat\u00e9riel de commercialisation, et de le faire en conformit\u00e9 avec les termes du pr\u00e9sent accord.",
        "aff_str13_para": "Le Partenaire s'engage \u00e0 ne pas associer les Mat\u00e9riels de marketing \u00e0 un contenu qui est ill\u00e9gal de quelque mani\u00e8re que ce soit, ou qui est autrement nuisible, mena\u00e7ant, diffamatoire, obsc\u00e8ne, offensant, harcelant, sexuellement explicite, violent, discriminatoire, ou autrement r\u00e9pr\u00e9hensible \u00e0 la seule discr\u00e9tion de PeopleLink. Le Partenaire s'engage \u00e0 ne pas envoyer de messages \u00e9lectroniques non sollicit\u00e9s \u00e0 de multiples destinataires non li\u00e9s (\"Spamming\") pour promouvoir les services et solutions PeopleLink, ou \u00e0 s'engager de toute autre mani\u00e8re dans toute autre forme de communication \u00e9lectronique de masse interdite par la loi en relation avec les activit\u00e9s envisag\u00e9es dans le cadre du pr\u00e9sent accord.",
        "aff_str14_para1": "Le partenaire accepte express\u00e9ment de se conformer \u00e0 toutes les conditions \u00e9nonc\u00e9es dans le pr\u00e9sent document lors de l'utilisation des marques sous licence et de la cr\u00e9ation de mat\u00e9riel de marketing.",
        "aff_str14_para2": "Par le biais des Directives et autres, PeopleLink fournira de temps \u00e0 autre des sp\u00e9cifications et autres instructions concernant l'utilisation autoris\u00e9e des marques sous licence par le Partenaire dans la cr\u00e9ation de mat\u00e9riel de marketing et la promotion du service PeopleLink. Le partenaire s'engage en outre \u00e0 se conformer \u00e0 toutes ces sp\u00e9cifications et instructions.",
        "aff_str14_para3": "Le partenaire doit s'assurer que toutes les marques sous licence apparaissant sur ses supports marketing sont sous la forme approuv\u00e9e par PeopleLink dans les directives ou autrement, ne doit pas modifier les marques PeopleLink ou autrement modifier substantiellement d'autres supports marketing contrairement aux instructions raisonnables fournies par PeopleLink, et doit en outre se conformer aux instructions raisonnables de PeopleLink quant \u00e0 la forme, au contenu et \u00e0 l'affichage des supports marketing. En cas de r\u00e9siliation du pr\u00e9sent accord pour quelque raison que ce soit, ou sur demande \u00e9crite de PeopleLink, la licence accord\u00e9e dans le pr\u00e9sent accord expirera et le Partenaire devra imm\u00e9diatement cesser toutes ses activit\u00e9s dans le cadre du pr\u00e9sent accord.",
        "aff_str15_para": "Le Partenaire est seul responsable de ses op\u00e9rations en agissant dans le cadre du pr\u00e9sent Accord, y compris, sans limitation, la l\u00e9galit\u00e9 des op\u00e9rations et des mat\u00e9riaux du Partenaire, cr\u00e9\u00e9s et utilis\u00e9s en relation avec le pr\u00e9sent Accord. \u00c0 l'exception d'une r\u00e9clamation all\u00e9guant qu'une marque PeopleLink viole les droits de marque d'un tiers, PeopleLink n'est pas responsable du d\u00e9veloppement, de l'exploitation ou du contenu des mat\u00e9riels de marketing du partenaire et le partenaire s'engage \u00e0 d\u00e9fendre, indemniser et tenir PeopleLink \u00e0 l'\u00e9cart de toute r\u00e9clamation, action, cause d'action, dommages ou frais (y compris les frais d'avocat) li\u00e9s au d\u00e9veloppement, \u00e0 l'exploitation, au contenu et \u00e0 la maintenance des mat\u00e9riels de marketing du partenaire.",
        "aff_str16_para": "Pendant et apr\u00e8s la Dur\u00e9e, PeopleLink sera le propri\u00e9taire exclusif de toutes les relations cr\u00e9\u00e9es par l'interm\u00e9diaire du Partenaire parmi PeopleLink et les R\u00e9f\u00e9rents en ce qui concerne le Service PeopleLink, y compris toute information identifiant les R\u00e9f\u00e9rents qui contractent avec PeopleLink pour l'utilisation du Service PeopleLink. Les conditions, la politique de confidentialit\u00e9 et les r\u00e8gles et proc\u00e9dures de PeopleLink pour le service PeopleLink s'appliqueront \u00e0 ces r\u00e9f\u00e9rences et peuvent \u00eatre modifi\u00e9es par PeopleLink sans pr\u00e9avis au partenaire, et le partenaire accepte de transmettre aux r\u00e9f\u00e9rences la nature de leurs relations avec PeopleLink en vertu des conditions.",
        "aff_str20_para1": "r\u00e9f\u00e9r\u00e9s par le partenaire \u00e0 PeopleLink et qui remplissent la proc\u00e9dure d'inscription conform\u00e9ment \u00e0 la proc\u00e9dure d\u00e9crite \u00e0 la section 3(b) ci-dessous ;",
        "aff_str20_para2": "dont PeopleLink n'a aucune trace en relation avec le service PeopleLink, ou qui ne sont pas, au moment o\u00f9 le partenaire en r\u00e9f\u00e8re \u00e0 PeopleLink, dans des relations contractuelles ou des n\u00e9gociations en cours avec PeopleLink en relation avec le service PeopleLink ;",
        "aff_str20_para3": "qui acceptent les Conditions et acqui\u00e8rent, \u00e0 la discr\u00e9tion du Parrain et sans recevoir d'incitation mon\u00e9taire ou autre du Partenaire, au moins un abonnement annuel \u00e0 l'un des forfaits de services PeopleLink suivants figurant sur les sites Web de PeopleLink ou autrement (iv) qui ne sont pas rejet\u00e9s par PeopleLink, et effectuent au moins un paiement (paiement annuel anticip\u00e9) ou trois paiements (terme annuel, facturation mensuelle) pour recevoir le Service PeopleLink.",
        "aff_str21": "Proc\u00e9dure de renvoi.",
        "aff_str22": "Commissions. Responsabilit\u00e9s.",
        "aff_str221": "Frais de recommandation.",
        "aff_str222": "Ventes en cours \u00e0 partir d'une recommandation",
        "aff_str223": "Frais connexes.",
        "aff_str23": "Rapports des ventes\/commissions.",
        "aff_str21_para": "Chaque r\u00e9f\u00e9rence sera adress\u00e9e \u00e0 PeopleLink par le partenaire par le biais d'une url en ligne fournie par PeopleLink au partenaire, PeopleLink sera responsable du processus de vente \u00e0 toutes les r\u00e9f\u00e9rences, sous r\u00e9serve de la coop\u00e9ration continue de bonne foi des parties dans la promotion du processus de vente \u00e0 la r\u00e9f\u00e9rence.",
        "aff_str22_para": "PeopleLink per\u00e7oit tous les frais du service PeopleLink directement aupr\u00e8s de Referral.",
        "aff_str22_para1": "Lorsqu'une recommandation devient une recommandation qualifi\u00e9e, PeopleLink paiera les frais de recommandation du Partenaire \u00e0 terme \u00e9chu sur la base des frais \u00e9num\u00e9r\u00e9s \u00e0 l'adresse",
        "aff_str22_para12": "(\u00e0 l'exclusion de tout rabais) payable par le r\u00e9f\u00e9rent qualifi\u00e9. Ces commissions de recommandation doivent \u00eatre pay\u00e9es au partenaire dans un d\u00e9lai d'environ (<add) quatre-vingt-dix (90) jours \u00e0 compter de la date de d\u00e9but du service payant pour lequel les obligations de paiement ont \u00e9t\u00e9 accord\u00e9es.",
        "aff_str22_para2": "- Le partenaire recevra des commissions pour les ventes suppl\u00e9mentaires provenant d'une recommandation qualifi\u00e9e qui ont lieu dans les 90 premiers jours suivant la date \u00e0 laquelle la recommandation a \u00e9t\u00e9 soumise initialement.",
        "aff_str22_para3": " Le Partenaire est responsable du paiement de tous les imp\u00f4ts, droits, charges gouvernementales et autres charges similaires pr\u00e9lev\u00e9es sur les Commissions de recommandation, et le Partenaire doit indemniser, d\u00e9fendre et tenir PeopleLink \u00e0 l'\u00e9cart de toute r\u00e9clamation d\u00e9coulant ou li\u00e9e \u00e0 toutes les charges \u00e9manant du paiement des Commissions de recommandation par PeopleLink.",
        "aff_str23_para": "PeopleLink doit fournir au Partenaire dans son rapport de tableau de bord en ligne r\u00e9sumant les activit\u00e9s de vente du Partenaire et ses commissions pour les R\u00e9f\u00e9rences Qualifi\u00e9es d\u00e9riv\u00e9es des R\u00e9f\u00e9rences. PeopleLink ne doit pas r\u00e9v\u00e9ler les noms ou autres informations personnelles concernant les r\u00e9f\u00e9rences et les r\u00e9f\u00e9rences qualifi\u00e9es.",
        "aff_str31": "Terme initial.",
        "aff_str32": "Dur\u00e9e de renouvellement.",
        "aff_str33": "R\u00e9siliation anticip\u00e9e. Sans motif.",
        "aff_str34": "Pour la cause.",
        "aff_str35": "Effet de la r\u00e9siliation.",
        "aff_str31_para": "Le pr\u00e9sent accord entre en vigueur \u00e0 la date d'entr\u00e9e en vigueur et se poursuit pendant douze (12) mois par la suite (\"Dur\u00e9e initiale\"), \u00e0 moins que PeopleLink ne rejette la demande de participation des Partenaires au programme",
        "aff_str32_para": "Apr\u00e8s l'expiration de la p\u00e9riode initiale, le pr\u00e9sent accord sera automatiquement renouvel\u00e9 pour des p\u00e9riodes cons\u00e9cutives suppl\u00e9mentaires de douze (12) mois (chacune, \"p\u00e9riode de renouvellement\"), \u00e0 moins qu'une partie ne donne un pr\u00e9avis \u00e9crit de r\u00e9siliation \u00e0 l'autre partie au moins trente (30) jours avant la fin de la p\u00e9riode initiale ou de toute p\u00e9riode de renouvellement.",
        "aff_str33_para": "PeopleLink a le droit de r\u00e9silier le pr\u00e9sent accord \u00e0 tout moment, pour quelque raison que ce soit ou sans raison, en donnant un pr\u00e9avis \u00e9crit de cinq (5) jours au partenaire.",
        "aff_str34_para": "Chaque partie peut r\u00e9silier le pr\u00e9sent accord \u00e0 tout moment, avec effet imm\u00e9diat sur notification \u00e9crite \u00e0 l'autre partie qui a commis une violation substantielle du pr\u00e9sent accord, \u00e0 condition qu'avant de r\u00e9silier le pr\u00e9sent accord, la partie qui a r\u00e9sili\u00e9 le pr\u00e9sent accord fournisse une notification \u00e9crite de cette violation substantielle et donne \u00e0 la partie en infraction la possibilit\u00e9 de rem\u00e9dier \u00e0 cette violation dans un d\u00e9lai de trente (30) jours.",
        "aff_str35_para": "\u00c0 partir de la date de r\u00e9siliation du pr\u00e9sent Accord et apr\u00e8s, les droits du Partenaire en vertu du pr\u00e9sent Accord seront r\u00e9sili\u00e9s, et le Partenaire n'aura pas le droit de recevoir des commissions de r\u00e9f\u00e9rence ou tout autre paiement en vertu du pr\u00e9sent Accord autre que les commissions ou les paiements gagn\u00e9s ou accumul\u00e9s avant la r\u00e9siliation du pr\u00e9sent Accord.",
        "aff_str41": "Affectation.",
        "aff_str42": "Droits de propri\u00e9t\u00e9 intellectuelle.",
        "aff_str43": "Pas de renonciation.",
        "aff_str44": "Garantie limit\u00e9e.",
        "aff_str45": "Exclusion de garantie.",
        "aff_str46": "Limitation de la responsabilit\u00e9.",
        "aff_str47": "Entrepreneurs ind\u00e9pendants.",
        "aff_str48": "Indemnisation.",
        "aff_str49": "Force Majeure.",
        "aff_str410": "Accord int\u00e9gral ; s\u00e9parabilit\u00e9.",
        "aff_str411": "Contreparties ; Avis.",
        "aff_str412": "Droit applicable ; juridiction ; r\u00e8glement des litiges.",
        "aff_str41_para": "PeopleLink peut c\u00e9der le pr\u00e9sent accord \u00e0 tout moment. Le Partenaire ne peut c\u00e9der ou transf\u00e9rer le pr\u00e9sent Accord sans le consentement \u00e9crit pr\u00e9alable de PeopleLink, ce consentement ne devant pas \u00eatre refus\u00e9 de mani\u00e8re d\u00e9raisonnable.",
        "aff_str42_para": "Tous les droits de propri\u00e9t\u00e9 intellectuelle (tels que, mais sans s'y limiter, les marques, les noms commerciaux, les logos, les brevets, les droits d'auteur, les noms de domaine et les droits d\u00e9riv\u00e9s) des marques PeopleLink, du service PeopleLink et du contenu et de la technologie connexes dans le monde entier (droits de propri\u00e9t\u00e9 intellectuelle de PeopleLink) sont et resteront la propri\u00e9t\u00e9 exclusive de PeopleLink et de ses filiales. Le droit du partenaire d'utiliser les marques sous licence est \u00e0 la discr\u00e9tion de PeopleLink et est soumis au respect par le partenaire des conditions du pr\u00e9sent accord, des directives et de toutes les lois et r\u00e9glementations applicables. Le partenaire s'engage \u00e0 (a) ne pas utiliser les droits de propri\u00e9t\u00e9 intellectuelle de PeopleLink d'une mani\u00e8re raisonnablement susceptible de violer le pr\u00e9sent accord ; (b) ne rien faire qui conteste ou compromette les droits de propri\u00e9t\u00e9 intellectuelle de PeopleLink ; (c) ne pas cr\u00e9er ou obtenir des droits de propri\u00e9t\u00e9 intellectuelle (tels que, mais sans s'y limiter, les marques, les noms commerciaux, les logos, les brevets, les droits d'auteur, les noms de domaine et les droits d\u00e9riv\u00e9s) qui sont essentiellement similaires aux droits de propri\u00e9t\u00e9 intellectuelle de PeopleLink ; (d) informer rapidement PeopleLink de toute utilisation non autoris\u00e9e de tout droit de propri\u00e9t\u00e9 intellectuelle de PeopleLink dont le partenaire a effectivement connaissance ; et (e) toujours utiliser les marques sous licence et toutes les autres marques de PeopleLink conform\u00e9ment aux lignes directrices. PeopleLink peut effectuer des examens p\u00e9riodiques de tout mat\u00e9riel de marketing pr\u00e9sent\u00e9 par le partenaire, et aura l'autorit\u00e9 et la discr\u00e9tion exclusives d'ordonner le retrait et\/ou la modification de tout mat\u00e9riel de marketing pr\u00e9sent\u00e9 par le partenaire.",
        "aff_str43_para": "Le fait qu'une partie ne fasse pas respecter par l'autre partie la stricte ex\u00e9cution d'une disposition du pr\u00e9sent accord ne constitue pas une renonciation au droit de la premi\u00e8re partie de faire respecter ult\u00e9rieurement cette disposition ou toute autre disposition du pr\u00e9sent accord.",
        "aff_str44_para": "Les deux parties garantissent qu'\u00e0 tout moment pendant la dur\u00e9e du contrat, elles se conformeront \u00e0 toutes les lois, r\u00e9glementations et codes de pratique applicables, ainsi qu'au pr\u00e9sent contrat, aux conditions, \u00e0 la politique de confidentialit\u00e9 et aux lignes directrices. Pendant la Dur\u00e9e et apr\u00e8s sa r\u00e9siliation pour quelque raison que ce soit, le Partenaire s'engage express\u00e9ment \u00e0 ne rien faire qui puisse raisonnablement \u00eatre consid\u00e9r\u00e9 comme nuisible aux affaires, aux int\u00e9r\u00eats ou \u00e0 la r\u00e9putation de PeopleLink et \u00e0 ne pas faire, publier ou permettre que soient faites ou publi\u00e9es des remarques d\u00e9sobligeantes concernant PeopleLink, ses repr\u00e9sentants ou le Service PeopleLink.",
        "aff_str45_para": "\u00c0 l'exception de la garantie expresse de PeopleLink pr\u00e9vue au paragraphe (e) pr\u00e9c\u00e9dent, PeopleLink ne donne aucune autre garantie, expresse ou implicite, de quelque nature que ce soit et PeopleLink d\u00e9cline express\u00e9ment toute garantie et condition, y compris, mais sans s'y limiter, toute garantie implicite de qualit\u00e9 marchande, d'ad\u00e9quation \u00e0 un usage particulier, de disponibilit\u00e9, de s\u00e9curit\u00e9, de titre et\/ou de non-violation de l'objet du pr\u00e9sent accord.",
        "aff_str46_para": "Ni PeopleLink, ni aucun de ses dirigeants, employ\u00e9s, directeurs ou tout autre repr\u00e9sentant de PeopleLink ne peut \u00eatre tenu responsable envers le Partenaire ou envers tout tiers, en vertu ou en relation avec le pr\u00e9sent accord ou sa r\u00e9siliation, dans le cadre d'un contrat, d'un pr\u00e9-contrat, d'un d\u00e9lit ou autrement, pour (i) toute perte \u00e9conomique (y compris la perte de revenus, de b\u00e9n\u00e9fices, de contrats, d'affaires ou d'\u00e9conomies anticip\u00e9es) ou (ii) toute perte de bonne volont\u00e9 ou de r\u00e9putation. Ces pertes comprennent, sans limitation, toute perte ou tout dommage sp\u00e9cial, indirect, accessoire, statutaire, punitif ou cons\u00e9cutif, ainsi que toute perte ou tout dommage caus\u00e9 par l'interruption des activit\u00e9s. Nonobstant toute autre circonstance ou accord entourant toute relation entre les parties, la responsabilit\u00e9 enti\u00e8re de PeopleLink envers le Partenaire en vertu du pr\u00e9sent Accord ne doit pas d\u00e9passer INR (mille roupies indiennes seulement) pour toute demande de dommages de toute nature faite par le Partenaire en vertu du pr\u00e9sent Accord, et en entrant dans le pr\u00e9sent Accord, le Partenaire reconna\u00eet les limitations de la responsabilit\u00e9 de PeopleLink.",
        "aff_str47_para": "Les parties aux pr\u00e9sentes agissent en leur nom propre en tant que contractant ind\u00e9pendant. Rien dans le pr\u00e9sent accord ne doit cr\u00e9er de joint venture, d'agence, de franchise, de repr\u00e9sentant commercial, d'emploi ou toute autre relation entre les parties au-del\u00e0 des relations d\u00e9finies dans le pr\u00e9sent accord, et le Partenaire est express\u00e9ment emp\u00each\u00e9 d'agir au nom de PeopleLink. L'affichage par le Partenaire de marques sous licence dans le cadre du pr\u00e9sent Accord, d'autres contenus pr\u00e9sent\u00e9s par le Partenaire, ou le contact entre le Partenaire et des tiers ne doit pas d\u00e9former les relations d\u00e9crites dans le pr\u00e9sent Accord.",
        "aff_str48_para": "Le partenaire indemnisera, d\u00e9fendra et tiendra PeopleLink et ses filiales, soci\u00e9t\u00e9s affili\u00e9es, dirigeants et employ\u00e9s (les \"parties indemnis\u00e9es de PeopleLink\") \u00e0 l'abri de tous les co\u00fbts, responsabilit\u00e9s, pertes et d\u00e9penses (y compris, mais sans s'y limiter, les honoraires raisonnables d'avocat) r\u00e9sultant de toute r\u00e9clamation, poursuite, action, demande ou proc\u00e9dure intent\u00e9e par un tiers contre les parties indemnis\u00e9es de PeopleLink et d\u00e9coulant de l'un des \u00e9l\u00e9ments suivants : (i) une violation de l'accord par le partenaire ; (ii) la n\u00e9gligence, la n\u00e9gligence grave ou la mauvaise conduite d\u00e9lib\u00e9r\u00e9e du partenaire ou de ses employ\u00e9s, agents ou contractants ; ou (iii) un manquement par le partenaire ou ses employ\u00e9s, agents, contractants ou invit\u00e9s \u00e0 se conformer aux lois et r\u00e8glements mentionn\u00e9s ci-dessus.",
        "aff_str49_para": "Une partie n'est pas tenue d'ex\u00e9cuter l'une quelconque de ses obligations au titre des pr\u00e9sentes si elle est emp\u00each\u00e9e de le faire par une situation de force majeure. Les \u00e9v\u00e9nements de \"force majeure\" comprennent les \u00e9v\u00e9nements \u00e9chappant au contr\u00f4le raisonnable des Parties, y compris les cas de force majeure, les actes de gouvernement, les actes de nature, les gr\u00e8ves ou les \u00e9meutes, ainsi que la mauvaise ex\u00e9cution par les fournisseurs de PeopleLinks ou les d\u00e9fauts des objets, des mat\u00e9riaux ou des logiciels de tiers. Si une situation de force majeure dure plus de trente (30) jours, l'une ou l'autre des parties peut r\u00e9silier le pr\u00e9sent accord moyennant une notification \u00e9crite \u00e0 l'autre partie.",
        "aff_str410_para": "Le pr\u00e9sent accord repr\u00e9sente l'int\u00e9gralit\u00e9 de l'accord entre les parties concernant son objet et les obligations et engagements respectifs des parties. Aucun autre document ou accord oral ou \u00e9crit entre les parties ne refl\u00e8te de quelque fa\u00e7on que ce soit les accords \u00e9nonc\u00e9s dans le pr\u00e9sent accord, et le pr\u00e9sent accord ne peut \u00eatre modifi\u00e9 que par un \u00e9crit sign\u00e9 par les deux parties. . Dans la mesure du possible, chaque disposition du pr\u00e9sent accord doit \u00eatre interpr\u00e9t\u00e9e de mani\u00e8re \u00e0 \u00eatre efficace et valide en vertu du droit applicable, mais si une disposition du pr\u00e9sent accord est interdite ou invalide en vertu du droit applicable, cette disposition ne sera inefficace que dans la mesure de cette interdiction ou invalidit\u00e9, sans invalider le reste de cette disposition ou les autres dispositions du pr\u00e9sent accord.",
        "aff_str411_para": "Le pr\u00e9sent accord peut \u00eatre sign\u00e9 en plusieurs exemplaires et ces exemplaires sont valables et lient les parties au pr\u00e9sent accord avec le m\u00eame effet que si les signatures originales avaient \u00e9t\u00e9 \u00e9chang\u00e9es.",
        "aff_str412_para": "Le pr\u00e9sent accord est r\u00e9gi par les lois de la juridiction de Hyderabad, Telangana, Inde, sans donner effet \u00e0 aucun principe de conflit de lois. La comp\u00e9tence juridictionnelle est exclusivement attribu\u00e9e aux tribunaux de district d'Hyderabad, Telangana, Inde. La seule et unique juridiction et lieu de juridiction pour tout litige d\u00e9coulant du pr\u00e9sent accord sera un tribunal de district ou d'\u00c9tat appropri\u00e9 situ\u00e9 \u00e0 Hyderabad, Telangana, Inde, et les parties conviennent de ne pas soulever, et renoncent par les pr\u00e9sentes, \u00e0 toute objection ou d\u00e9fense fond\u00e9e sur la non convenance du lieu ou du forum. Avant d'engager toute action en justice d\u00e9coulant du pr\u00e9sent accord ou s'y rapportant, une partie doit fournir \u00e0 l'autre partie une notification \u00e9crite d'un litige et les parties doivent n\u00e9gocier activement et de bonne foi en vue d'une r\u00e9solution rapide de ce litige dans les trente (30) jours ouvrables suivant la r\u00e9ception de cette notification.",
        "aff_str40": "Modification de l'accord.",
        "aff_str40_para": "PeopleLink peut modifier le pr\u00e9sent accord de temps \u00e0 autre, \u00e0 sa discr\u00e9tion raisonnable, en publiant un changement sur le site (\u00e0 www.peoplelinkvc.com\/affiliatestermsofservice) ou en informant le partenaire par courrier \u00e9lectronique. Si le Partenaire s'oppose \u00e0 un tel changement, le Partenaire peut r\u00e9silier le pr\u00e9sent accord pour une raison valable. La poursuite de la participation du Partenaire au Programme apr\u00e8s la r\u00e9ception de la notification des modifications du pr\u00e9sent Accord constitue l'acceptation obligatoire du pr\u00e9sent Accord tel que modifi\u00e9.",
        "qualified_ref": "R\u00e9f\u00e9rents qualifi\u00e9s",
        "mean_referrals": "moyenne R\u00e9f\u00e9rents",
        "apply": "Appliquer",
        "company_code_validate": "Veuillez saisir le code de la soci\u00e9t\u00e9 pour valider",
        "golive_company_code": "Code des soci\u00e9t\u00e9s Golive",
        "accept_TC": "J'accepte les termes et conditions ci-dessus",
        "by_sub_referral": "En soumettant la demande de partenaire de r\u00e9f\u00e9rence, le partenaire d\u00e9clare et garantit qu'il a lu, compris et accept\u00e9 le pr\u00e9sent accord.",
        "term": "Termes",
        "found_at": "trouv\u00e9 \u00e0",
        "our_privacy_policy": "et notre politique de confidentialit\u00e9",
        "privacy_policy": "Politique de confidentialit\u00e9",
        "as_applicable": "selon le cas.",
        "screen-sharing": "partage d'\u00e9cran",
        "whiteboard_access": "acc\u00e8s au tableau blanc",
        "Document_access": "Acc\u00e8s aux documents",
        "share_the_screen": "partagez l'\u00e9cran !",
        "to_collaborate": "pour collaborer !",
        "share_document": "partagez le document !",
        "exit_or_end": "Sortir ou arr\u00eater la r\u00e9union ?",
        "exit_from_meeting": "Souhaitez-vous sortir de la r\u00e9union ?",
        "are_sure_exit_meeting_everyone": "\u00cates-vous s\u00fbr de vouloir quitter la r\u00e9union ? Vous pouvez soit mettre fin \u00e0 la r\u00e9union pour tout le monde, soit vous retirer de la r\u00e9union.",
        "are_sure_exit_meeting": "\u00cates-vous s\u00fbr de vouloir quitter la r\u00e9union ?",
        "exit_meeting": "Sortie de la R\u00e9union",
        "end_for_all": "Cl\u00f4turer la r\u00e9union pour tous",
        "end_meeting": "R\u00e9union de cl\u00f4ture",
        "will_let_alone_exit": "vous laissera seul pour sortir ou quitter la r\u00e9union.",
        "will_end_for_everyone": "terminera la r\u00e9union pour tous les participants \u00e0 la conf\u00e9rence (tous les participants et les personnes pr\u00e9sentes).",
        "user_already_exists": "Les utilisateurs existent d\u00e9j\u00e0",
        "already_user_avail": "Il y a d\u00e9j\u00e0 quelques utilisateurs pr\u00e9sents dans la r\u00e9union.",
        "if_like_continue": "Si vous souhaitez continuer, cliquez sur",
        "force_start_meetinh": "Forcer le d\u00e9marrage d'une autre r\u00e9union",
        "otherwise_click": "sinon cliquez sur",
        "to_go_back": "Pour revenir en arri\u00e8re.",

        //New by Keerthi - 17th Sep 2020
        "lang_settings" : "Language Settings",
        "lang_info" : "Choose your preferred language to use the application.",
        "select_language" : "Select Language",
        "settings_languages" : "Languages",

        "rec_plugin" : "Recording Plugin",
        "rec_heading1" : "How to install and manage InstaVC Screen-Video Recorder with the plugin",
        "rec_step1" : "Step 1: Copy & open Link in Chrome",
        "rec_step1_para" : "First copy the link ",
        "rec_step1_para_br" : "from here and open it in chrome to add the plugin to your browser. Click on ",
        "rec_step1_para_bold" : "Add to Chrome",
        "rec_step1_para_ct" : "to add this extension.",

        "rec_step2" : "Step 2: Pop Up for Permission",
        "rec_step2_para_br" : "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
        "rec_step2_para_bold" : "Add Extension",
        "rec_step2_para_ct" : "to proceed.",

        "rec_step3" : "Step 3: Extension Added to Chrome",
        "rec_step3_para" : "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

        "rec_step4" : "Step 4: Pin the plugin on the toolbar",
        "rec_step4_para_br" : "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
        "rec_step4_para_bold" : "InstaVC Screen-Recording",
        "rec_step4_para_ct" : "and click on the pin icon to add.",

        "rec_step5" : "Step 5: Extension/Plugin Pinned to Toolbar",
        "rec_step5_para" : "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access." ,

        "rec_step6" : "Step 6: InstVC Recorder Setup",
        "rec_step6_para_br" : "Once you have installed the plugin and the next time when you open it, you can now see the ",
        "rec_step6_para_bold" : "InstaVC Recorder Setup",
        "rec_step6_para_ct" : "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
        "rec_step6_para_bold1" : "Next",
        "rec_step6_para_ct1" : "to continue.",

        "rec_step7" : "Step 7: Additional Permissions",
        "rec_step7_para_br" : "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
        "rec_step7_para_bold" : "Allow",
        "rec_step7_para_ct" : "to continue.",

        "rec_step8" : "Step 8: Permissions Allowed",
        "rec_step8_para" : "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

        "rec_heading2" : "Desktop Screen-Recording Plugin",

        "rec_step9" : "Step 9: Desktop Screen-Recording",
        "rec_step9_para_br" : "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
        "rec_step9_para_bold" : "Desktop Screen Recording",
        "rec_step9_para_ct" : "and click on the",
        "rec_step9_para_bold1" : "Record",
        "rec_step9_para_ct1" : "button to start.",

        "rec_step9a" : "Step 9(a): Share your Screen Popup",
        "rec_step9a_para_br" : "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
        "rec_step9a_para_bold" : "Share",
        "rec_step9a_para_ct" : "button and go to that screen which you want to start recording.",

        "rec_step9b" : "Step 9(b): Desktop Screen Recording Started",
        "rec_step9b_para_br" : "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
        "rec_step9b_para_bold" : "Stop Sharing",
        "rec_step9b_para_ct" : "or",
        "rec_step9b_para_bold1" : "Hide",
        "rec_step9b_para_ct1" : ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

        "rec_step9c" : "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
        "rec_step9c_para_br" : "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
        "rec_step9c_para_bold" : "Restart, Pause",
        "rec_step9c_para_ct" : "and",
        "rec_step9c_para_bold1" : "Stop",
        "rec_step9c_para_ct1" : "buttons. You can click any of those accordingly.",

        "rec_step9d" : "Step 9(d):Recent Recording View",
        "rec_step9d_para_br" : "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
        "rec_step9d_para_bold" : "Download",
        "rec_step9d_para_ct" : "option in the top and the recording details in the right column.",
        
        "rec_heading3" : "Browser Tab Screen-Recording Plugin",

        "rec_step10" : "Step 10: Browser Tab Screen-Recording",
        "rec_step10_para_br" : "When we want to select ",
        "rec_step10_para_bold" : "Browser Tab",
        "rec_step10_para_ct" : "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
        "rec_step10_para_bold1" : "Record",
        "rec_step10_para_ct1" : "button to start recording.",

        "rec_step10a" : "Step 10(a): Browser Tab is being Recorded",
        "rec_step10a_para" : "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",
        
        "rec_step10b" : "Step 10(b): Record another tab",
        "rec_step10b_para_br" : "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
        "rec_step10b_para_bold" : "Record This Tab",
        "rec_step10b_para_ct" : "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

        "rec_step10c" : "Step 10(C): Stop and View recording",
        "rec_step10c_para_br" : "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
        "rec_step10c_para_bold" : "Download",
        "rec_step10c_para_ct" : "Option at the top and the recording details in the right column.",

        "rec_heading4" : "Webcam Recording",

        "rec_step11" : "Step 11: Start Webcam Screen Recording",
        "rec_step11_para_br" : "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
        "rec_step11_para_bold" : "Record",
        "rec_step11_para_ct" : "button to start with.",

        "rec_step11a" : "Step 11(a): Webcam opens Self Video and starts Recording",
        "rec_step11a_para_br" : "The recording opens a web page with yourself video with",
        "rec_step11a_para_bold" : "Pause",
        "rec_step11a_para_ct" : "and",
        "rec_step11a_para_bold1" : "Stop",
        "rec_step11a_para_ct1" : "recording options at the bottom.",

        "rec_step11b" : "Step 11(b): View Webcam Recorded Video",
        "rec_step11b_para" : "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",
        
        "rec_heading5" : "Top Menus in Recording Plugin",

        "rec_step12" : "Step 12: Navigation Menus",
        "rec_step12_para_br" : "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
        "rec_step12_para_bold" : "Hamburger Menu",
        "rec_step12_para_ct" : "Click on it to open.",

        "rec_step12a" : "Step 12(a): Open Hamburger Menu",
        "rec_step12a_para_br" : "On click of",
        "rec_step12a_para_bold" : "Hamburger Menu",
        "rec_step12a_para_ct" : ", you can find 2 tabs named",
        "rec_step12a_para_bold1" : "My Recordings",
        "rec_step12a_para_ct1" : "and",
        "rec_step12a_para_bold2" : "Options",
        "rec_step12a_para_ct2" : "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
        "rec_step12a_para_bold3" : "My Recordings",
        "rec_step12a_para_ct3" : "to see the videos you have recorded till date.",

        "rec_step12b" : "Step 12(b): Access My Recordings",
        "rec_step12b_para_br" : "There is another way of accessing",
        "rec_step12b_para_bold" : "My Recordings",
        "rec_step12b_para_ct" : ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",
        
        "rec_step12c" : "Step 12(c): My Recordings",
        "rec_step12c_para" : "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

        "rec_step12d" : "Step 12(d): Delete All recordings",
        "rec_step12d_para_br" : "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
        "rec_step12d_para_bold" : "Delete All",
        "rec_step12d_para_ct" : "option to easily delete all recordings with a single click.",
        
        "rec_step12e" : "Step 12(e): Side Navigation",
        "rec_step12e_para_br" : "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
        "rec_step12e_para_bold" : "Options",
        "rec_step12e_para_ct" : "page",

        "rec_heading6" : "Plugin Options",

        "rec_step13" : "Step 13: Plugin Options",
        "rec_step13_para_br" : "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
        "rec_step13_para_bold" : "Options",
        "rec_step13_para_ct" : "to see the options that are enabled for you.",

        "rec_step13a" : "Step 13(a): Recorder Options",
        "rec_step13a_para" : "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

        "rec_step13b" : "Step 13(b): Recorder Options",
        "rec_step13b_para" : "Recorder Options contain various other options like Recording Settings and advanced.",

        "rec_heading7" : "Plugin Notifications",

        "rec_step14" : "Step 14: Plugin Notifications",
        "rec_step14_para" : "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

        "rec_step14a" : "Step 14(a): Open Notifications",
        "rec_step14a_para" : "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

        "rec_heading8" : "Recording Settings",

        "rec_step15" : "Step 15: Settings",
        "rec_step15_para_br" : "Then comes the last navigation menu on the top right corner named",
        "rec_step15_para_bold" : "Settings",
        "rec_step15_para_ct" : "where you can open and manage the recording settings accordingly.",

        "rec_step15a" : "Step 15(a): Advanced Settings Options",
        "rec_step15a_para" : "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

        "crteContent_upload_medialist" : "Uploaded Media List",
        "content_upld_desc_txt" : "The files you upload here will be available to users who view content.",
        "content_browse_txt" : "Browse Files to Upload",
        "content_upld_types" : "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

        "video_qlty": "Qualité vidéo",
        "audio_qlty": "Qualité audio",
        "cntnt_shrng": "Partage de contenu",
        "fdb_poor": "Pauvres",
        "fdb_good": "Bien",
        "fdb_avg": "Moyen",
        "fdb_excellent": "Excellent",
        "share_feedback": "Partagez votre FeedBack",
        "ovrl_rating": "Note globale",
        "fdb_cmnts": "Vos commentaires sont très appréciés",
        "no_thnks": "Non merci",
        "upload_size_max_15mb": "Vous pouvez télécharger la limite de taille maximale est de 15 Mo",
        
        "pastMeeting_feedback" : "Retour",
        "pastMeeting_comments" : "commentaires",
        
        "microsoft_webplugin" : "Plug-in Web Microsoft Outlook",
        "microsoft_installable" : "Plug-in installable Microsoft Outlook",
        "outlook_installable": "Outlook installable",
        "customization_installer": "Comment accéder au programme d'installation de personnalisation",
        "plugin_step1" : "Étape 1: Cliquez sur le lien pour télécharger le fichier",
        "click_link_download": "Cliquez sur le lien pour télécharger le fichier",
        "first_click_link": "Cliquez d'abord sur le lien ci-dessous",
        "to_download_file": "pour télécharger le fichier dans votre système. Ensuite, ouvrez le fichier téléchargé pour démarrer l'installation et cliquez sur",
        "install_txt": "Installer",
        "plugin_step2" : "Étape 2: personnalisation installée",
        "plugin_step2_para":"Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
        "plugin_step3" : "Étape 3: Ouvrez Outlook et accédez aux réunions",
        "plugin_step3_para" : "Après l'installation, ouvrez Microsoft Outlook et allez aux réunions.",
        "plugin_step3_para1" : "Accédez à Nouvel e-mail> Réunions",
        "plugin_step4" : "Étape 4: Réunions ouvertes",
        "plugin_step4_para" : "Une fois que la fenêtre des réunions est ouverte, déplacez-vous sur la liste des onglets ci-dessus et vous pouvez ensuite cliquer sur l'onglet",
        "plugin_step4_para1": "Peoplelink",
        "plugin_step5": "Étape 5: Programmer une conférence",
        "plugin_step5_para": "Sous Peoplelink, vous avez un sous-onglet nommé",
        "plugin_step5_para1": "Programmer une conférence.",
        "plugin_step5_para2": "Cliquez dessus et vous pouvez voir les options de planification sur le côté droit de la fenêtre. Ici, vous pouvez gérer les horaires inVC.",
        "plugin_step6": "Étape 6: Gérer ou personnaliser les horaires",
        "plugin_step6_para": "Ici, vous pouvez gérer ou personnaliser les horaires en fonction de la liste des salles, des horaires et créer un nouvel horaire à partir d'ici qui vous redirige vers le navigateur et retourne à Outlook.",
        "plugin_step6_para1": "Une fois que vous êtes d'accord avec l'horaire, vous pouvez cliquer sur",
        "plugin_step6_para2": "Obtenir le lien",
        "plugin_step7": "Lien généré",
        "plugin_step7_para": "Ensuite, voici le lien généré et composé dans le courrier que vous pouvez même l'utiliser pour partager en ligne ou continuer.",
    }
}